var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg404ErrorwithpersonlookingforRafiki1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 154,
    viewBox: "0 0 240 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_826_2135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240 125.553H0V125.673H240V125.553Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.952 133.275H200.054V133.395H215.952V133.275Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.986 134.581H154.814V134.701H158.986V134.581Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.574 128.821H190.363V128.941H199.574V128.821Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.9119 129.628H25.1807V129.748H45.9119V129.628Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.2269 129.628H50.1885V129.748H53.2269V129.628Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.072 131.653H63.1055V131.773H108.072V131.653Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.76 104.144H21.0768C20.3507 104.143 19.6548 103.854 19.1419 103.34C18.6289 102.826 18.3408 102.13 18.3408 101.404V-28.8828C18.3471 -29.6047 18.638 -30.295 19.1503 -30.8037C19.6626 -31.3123 20.3549 -31.5984 21.0768 -31.5996H113.76C114.487 -31.5996 115.184 -31.3108 115.698 -30.7968C116.212 -30.2828 116.501 -29.5857 116.501 -28.8588V101.404C116.501 102.13 116.212 102.828 115.698 103.342C115.184 103.856 114.487 104.144 113.76 104.144ZM21.0768 -31.5036C20.3826 -31.5023 19.7172 -31.2257 19.2267 -30.7343C18.7363 -30.2429 18.4608 -29.5771 18.4608 -28.8828V101.404C18.4608 102.098 18.7363 102.764 19.2267 103.255C19.7172 103.746 20.3826 104.023 21.0768 104.024H113.76C114.455 104.023 115.121 103.747 115.612 103.255C116.103 102.764 116.38 102.098 116.381 101.404V-28.8828C116.38 -29.5775 116.103 -30.2434 115.612 -30.7346C115.121 -31.2258 114.455 -31.5023 113.76 -31.5036H21.0768Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.589 104.144H124.901C124.174 104.143 123.478 103.854 122.964 103.34C122.451 102.827 122.161 102.13 122.16 101.404V-28.8828C122.168 -29.6052 122.46 -30.2954 122.973 -30.804C123.486 -31.3125 124.179 -31.5984 124.901 -31.5996H217.589C218.31 -31.5971 219.001 -31.3105 219.512 -30.802C220.024 -30.2934 220.314 -29.6039 220.32 -28.8828V101.404C220.32 102.129 220.033 102.825 219.521 103.338C219.009 103.852 218.314 104.142 217.589 104.144ZM124.901 -31.5036C124.206 -31.5023 123.54 -31.2258 123.049 -30.7346C122.558 -30.2434 122.281 -29.5775 122.28 -28.8828V101.404C122.281 102.098 122.558 102.764 123.049 103.255C123.54 103.747 124.206 104.023 124.901 104.024H217.589C218.284 104.023 218.95 103.747 219.441 103.255C219.932 102.764 220.208 102.098 220.21 101.404V-28.8828C220.208 -29.5775 219.932 -30.2434 219.441 -30.7346C218.95 -31.2258 218.284 -31.5023 217.589 -31.5036H124.901Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.056 18.8965H33.2017V26.0965H202.056V18.8965Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.272 18.1328H200.621V26.8544H202.272V18.1328Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.463 18.1328H144.812V26.8544H146.463V18.1328Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6575 18.1328H89.0063V26.8544H90.6575V18.1328Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8529 18.1328H33.2017V26.8544H34.8529V18.1328Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.837 18.1328H168.499V26.8544H179.837V18.1328Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.119 7.37207H173.218V19.2713H175.119V7.37207Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.602 10.096C179.499 8.19897 179.499 5.12331 177.602 3.2263C175.705 1.32929 172.629 1.32928 170.732 3.22629C168.835 5.1233 168.835 8.19897 170.732 10.096C172.629 11.993 175.705 11.993 177.602 10.096Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.6 6.66117C177.6 7.34375 177.398 8.011 177.019 8.57854C176.639 9.14609 176.1 9.58844 175.47 9.84965C174.839 10.1109 174.145 10.1792 173.476 10.046C172.806 9.91288 172.191 9.58419 171.709 9.10153C171.226 8.61887 170.897 8.00393 170.764 7.33446C170.631 6.66499 170.699 5.97107 170.96 5.34045C171.222 4.70982 171.664 4.17082 172.232 3.7916C172.799 3.41237 173.466 3.20996 174.149 3.20996C175.064 3.20996 175.942 3.57357 176.589 4.22079C177.237 4.86802 177.6 5.74585 177.6 6.66117Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.056 33.2969H33.2017V40.4969H202.056V33.2969Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.272 32.5332H200.621V41.2548H202.272V32.5332Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.462 32.5332H144.811V41.2548H146.462V32.5332Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6575 32.5332H89.0063V41.2548H90.6575V32.5332Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8529 32.5332H33.2017V41.2548H34.8529V32.5332Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1968 48.1768V55.3768H153.494C154.995 55.3761 156.481 55.6712 157.867 56.2451C159.253 56.819 160.513 57.6604 161.574 58.7214C162.635 59.7823 163.476 61.0419 164.05 62.4282C164.624 63.8145 164.919 65.3004 164.918 66.8008V125.663H172.118V66.7048C172.118 61.7925 170.168 57.0813 166.695 53.6069C163.222 50.1325 158.512 48.1793 153.6 48.1768H33.1968Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.462 47.4131H144.811V56.1347H146.462V47.4131Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6575 47.4131H89.0063V56.1347H90.6575V47.4131Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8529 47.4131H33.2017V56.1347H34.8529V47.4131Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.882 125.879V124.228H164.16V125.879H172.882Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.882 75.3494V73.6982H164.16V75.3494H172.882Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120 147.229C171.399 147.229 213.067 144.796 213.067 141.795C213.067 138.794 171.399 136.361 120 136.361C68.6002 136.361 26.9326 138.794 26.9326 141.795C26.9326 144.796 68.6002 147.229 120 147.229Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.433 138.766C205.985 138.674 205.531 138.608 205.075 138.569C204.855 138.516 204.65 138.412 204.477 138.266C204.304 138.119 204.169 137.933 204.081 137.724C202.886 136.807 202.051 135.199 201.355 134.167C200.875 134.071 200.395 133.956 199.949 133.822H199.92C199.206 134.278 198.366 134.5 197.52 134.455C196.617 134.388 195.629 133.495 196.027 132.492C196.392 131.556 196.949 130.803 197.985 130.572C198.362 130.514 198.742 130.487 199.123 130.491H199.277C199.277 130.491 199.277 130.491 199.301 130.467C199.325 130.443 199.142 130.543 199.219 130.419C199.37 130.154 199.601 129.944 199.878 129.819C200.156 129.694 200.466 129.66 200.765 129.723C202.685 129.036 203.515 129.123 203.515 127.044C203.519 126.747 203.563 126.452 203.645 126.166C203.645 125.892 203.645 125.619 203.645 125.34C203.688 124.38 204.389 122.719 203.981 122.038C203.501 121.255 202.286 120.761 201.734 119.863C201.701 119.805 201.673 119.744 201.648 119.681C201.202 119.582 200.792 119.362 200.462 119.047C200.214 119.114 199.952 119.11 199.706 119.036C199.46 118.961 199.239 118.819 199.07 118.625L198.288 118.491C198.037 118.639 197.748 118.707 197.457 118.687C196.819 119.532 195.398 119.887 194.837 118.687C193.838 116.542 194.385 113.7 197.318 114.075C197.664 114.122 197.993 114.253 198.278 114.454C198.769 114.427 199.262 114.456 199.747 114.54C200.1 114.331 200.503 114.218 200.913 114.214H202.795C202.795 114.156 202.795 114.108 202.824 114.046C202.884 113.247 202.884 112.445 202.824 111.646C202.751 110.478 202.914 109.307 203.304 108.204L203.141 107.844C201.182 107.46 197.673 107.643 196.872 107.441C196.658 107.399 196.458 107.307 196.287 107.173C196.116 107.038 195.979 106.866 195.888 106.668C195.68 106.475 195.516 106.239 195.408 105.977C195.17 105.362 195.023 104.715 194.971 104.057C194.967 103.785 195.036 103.518 195.171 103.282C195.306 103.046 195.502 102.851 195.739 102.718C195.976 102.601 196.221 102.503 196.473 102.425C196.761 102.109 197.107 101.85 197.491 101.662C197.702 101.424 197.962 101.235 198.254 101.109C198.546 100.982 198.863 100.922 199.181 100.932H199.32C199.883 100.729 200.409 100.434 200.875 100.059C201.629 99.4202 202.315 98.6666 203.424 98.8154H203.467V93.0554C200.491 92.9834 197.462 92.0282 195.753 89.441C195.134 88.481 195.686 87.6506 196.497 87.3242C196.513 87.2338 196.553 87.1494 196.613 87.08C196.673 87.0106 196.751 86.959 196.838 86.9306L201.067 85.625L193.92 79.5578L186.528 77.0522C186.528 77.0522 184.555 82.4186 181.977 82.3994C179.4 82.3802 175.344 87.6314 174.902 90.3194C174.461 93.0074 177.753 94.2506 174.902 95.6618C172.051 97.073 172.982 100.687 171.753 103.183C170.635 105.473 166.997 103.385 165.201 103.841C162.033 104.652 162.801 109.395 158.865 109.831C158.016 109.927 157.152 109.783 156.297 109.831C155.524 109.89 154.772 110.111 154.089 110.479C153.753 110.635 153.472 110.89 153.283 111.209C152.577 112.615 155.078 114.439 153.998 115.582C152.587 115.731 151.43 116.724 150.125 117.271C147.096 118.534 143.688 117.271 140.477 116.619C137.615 116.093 134.706 115.868 131.798 115.947C129.691 115.947 127.176 116.071 127.958 117.838L128.131 117.963C128.726 118.397 129.176 119.001 129.422 119.695C129.601 119.876 129.743 120.089 129.84 120.324C129.908 120.559 129.92 120.806 129.875 121.046C129.83 121.287 129.729 121.513 129.581 121.707C129.101 123.809 126.341 124.817 123.197 125.311C123.169 125.435 123.182 125.565 123.235 125.681C120.936 126.036 118.609 126.176 116.285 126.099C115.393 126.128 114.502 126.047 113.63 125.859C109.79 126.012 103.819 126.516 100.67 124.419C97.6318 122.393 97.9726 119.335 94.1326 118.083C91.987 117.382 92.251 115.644 91.219 114.041C89.7214 111.703 87.2686 112.505 86.1166 110.143C85.3438 108.55 82.8574 108.574 81.8926 107.086C81.3454 106.236 81.4462 105.132 81.6574 104.143C81.6854 103.909 81.7823 103.689 81.9358 103.51C82.123 103.332 82.4158 103.294 82.6126 103.135C83.0398 102.814 82.987 102.175 83.155 101.662C83.635 100.198 85.651 100.02 86.2846 98.6858C83.1598 96.3626 78.2686 94.9658 78.8926 89.9498C79.1422 87.9578 72.8158 87.017 71.0446 84.1898C69.2734 81.3626 65.803 85.9418 63.1054 80.1098C60.4078 74.2778 49.1086 75.5354 47.923 75.5402C46.7374 75.545 44.6686 81.329 41.683 82.1066C39.8686 82.5866 41.0974 84.5834 42.3454 86.4266C42.7489 86.324 43.1761 86.3735 43.5454 86.5658C43.5644 86.5813 43.5853 86.5943 43.6078 86.6042C44.1186 86.4817 44.6522 86.4916 45.1582 86.633C46.1182 86.9258 46.5982 87.7562 46.915 88.6346C46.9758 88.8069 46.9971 88.9906 46.9774 89.1722C47.2172 89.3839 47.3934 89.6581 47.4862 89.9642C47.5422 90.1615 47.5586 90.368 47.5343 90.5716C47.51 90.7753 47.4456 90.9721 47.3447 91.1507C47.2438 91.3293 47.1084 91.4861 46.9465 91.612C46.7846 91.7379 46.5993 91.8304 46.4014 91.8842C46.3527 91.8973 46.3029 91.9053 46.2526 91.9082L46.171 91.9898C45.9257 92.1733 45.6327 92.2823 45.327 92.3035C45.0214 92.3248 44.7161 92.2576 44.4478 92.1098C44.2322 92.0129 44.0265 91.8956 43.8334 91.7594C43.5646 92.3066 42.9646 92.7578 41.683 93.0314C38.6926 93.6698 37.9774 97.2458 38.6926 99.4538C38.7758 99.6968 38.7858 99.9588 38.7214 100.207C39.8926 100.207 41.0734 100.347 42.1918 100.371C45.2254 100.495 45.2446 105.171 42.1918 105.099C42.0334 105.099 41.875 105.099 41.7118 105.099C41.5708 105.437 41.3584 105.741 41.0892 105.989C40.8199 106.238 40.5002 106.425 40.1518 106.539C39.464 106.805 38.806 107.143 38.1886 107.547C38.3902 109.419 38.7886 111.641 38.5342 113.561C38.8361 113.624 39.1342 113.704 39.427 113.801C39.9336 113.964 40.4016 114.229 40.8027 114.579C41.2037 114.929 41.5294 115.356 41.7598 115.836C41.9948 115.687 42.2659 115.605 42.5441 115.598C42.8222 115.592 43.0969 115.661 43.339 115.798C43.5576 115.928 43.741 116.11 43.8732 116.328C44.0054 116.545 44.0824 116.792 44.0974 117.046C44.2078 117.07 44.3167 117.101 44.4238 117.137C44.4854 117.102 44.5496 117.071 44.6158 117.046C44.8011 116.951 45.0076 116.904 45.2158 116.911C45.4224 116.904 45.6274 116.951 45.811 117.046C45.9951 117.112 46.1601 117.222 46.291 117.367C46.3574 117.441 46.4199 117.518 46.4782 117.598L46.6702 117.747C46.8617 117.937 47.0006 118.173 47.0734 118.433C47.0734 118.567 47.107 118.707 47.1262 118.846C47.1379 119.053 47.0914 119.259 46.9918 119.441C46.9277 119.626 46.8169 119.791 46.6702 119.921C46.5414 120.069 46.3758 120.18 46.1902 120.243C46.0074 120.34 45.8018 120.386 45.595 120.377C45.4953 120.373 45.396 120.363 45.2974 120.348C45.1083 120.628 44.8171 120.823 44.4862 120.891C43.6306 121.071 42.7409 120.996 41.9278 120.675C41.5687 120.755 41.1985 120.773 40.8334 120.727C40.5829 120.692 40.3368 120.631 40.099 120.545C39.5676 120.877 38.9855 121.12 38.3758 121.265C38.4434 122.915 38.4194 124.567 38.3038 126.214C38.3038 126.406 38.3038 126.598 38.3038 126.799C39.3799 127.212 40.3842 127.792 41.2798 128.518C41.6032 128.75 41.8464 129.077 41.9758 129.454H42.0142C42.7414 129.4 43.4699 129.539 44.1262 129.857C45.0526 130.284 45.0862 131.643 44.443 132.295C44.275 132.463 44.107 132.617 43.939 132.775C43.9269 133.104 43.8107 133.421 43.6071 133.68C43.4036 133.939 43.1231 134.126 42.8062 134.215C42.5928 134.269 42.3764 134.309 42.1582 134.335C41.5901 134.77 40.8958 135.008 40.1806 135.012H40.0894C40.0049 135.344 39.8122 135.638 39.5418 135.847C39.2713 136.057 38.9387 136.17 38.5966 136.169C38.4815 136.162 38.3661 136.162 38.251 136.169C38.3038 136.169 37.939 136.356 38.0638 136.251C37.9123 136.392 37.7814 136.553 37.675 136.731C37.2025 137.498 36.5563 138.144 35.7886 138.617C35.5331 138.761 35.2413 138.828 34.9486 138.809C34.546 139.388 34.1836 139.995 33.8638 140.623H208.003C208.029 140.479 208.04 140.333 208.037 140.187C207.346 139.926 206.775 139.42 206.433 138.766Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M206.433 138.766C205.985 138.674 205.531 138.608 205.075 138.569C204.855 138.516 204.65 138.412 204.477 138.266C204.304 138.119 204.169 137.933 204.081 137.724C202.886 136.807 202.051 135.199 201.355 134.167C200.875 134.071 200.395 133.956 199.949 133.822H199.92C199.206 134.278 198.366 134.5 197.52 134.455C196.617 134.388 195.629 133.495 196.027 132.492C196.392 131.556 196.949 130.803 197.985 130.572C198.362 130.514 198.742 130.487 199.123 130.491H199.277C199.277 130.491 199.277 130.491 199.301 130.467C199.325 130.443 199.142 130.543 199.219 130.419C199.37 130.154 199.601 129.944 199.878 129.819C200.156 129.694 200.466 129.66 200.765 129.723C202.685 129.036 203.515 129.123 203.515 127.044C203.519 126.747 203.563 126.452 203.645 126.166C203.645 125.892 203.645 125.619 203.645 125.34C203.688 124.38 204.389 122.719 203.981 122.038C203.501 121.255 202.286 120.761 201.734 119.863C201.701 119.805 201.673 119.744 201.648 119.681C201.202 119.582 200.792 119.362 200.462 119.047C200.214 119.114 199.952 119.11 199.706 119.036C199.46 118.961 199.239 118.819 199.07 118.625L198.288 118.491C198.037 118.639 197.748 118.707 197.457 118.687C196.819 119.532 195.398 119.887 194.837 118.687C193.838 116.542 194.385 113.7 197.318 114.075C197.664 114.122 197.993 114.253 198.278 114.454C198.769 114.427 199.262 114.456 199.747 114.54C200.1 114.331 200.503 114.218 200.913 114.214H202.795C202.795 114.156 202.795 114.108 202.824 114.046C202.884 113.247 202.884 112.445 202.824 111.646C202.751 110.478 202.914 109.307 203.304 108.204L203.141 107.844C201.182 107.46 197.673 107.643 196.872 107.441C196.658 107.399 196.458 107.307 196.287 107.173C196.116 107.038 195.979 106.866 195.888 106.668C195.68 106.475 195.516 106.239 195.408 105.977C195.17 105.362 195.023 104.715 194.971 104.057C194.967 103.785 195.036 103.518 195.171 103.282C195.306 103.046 195.502 102.851 195.739 102.718C195.976 102.601 196.221 102.503 196.473 102.425C196.761 102.109 197.107 101.85 197.491 101.662C197.702 101.424 197.962 101.235 198.254 101.109C198.546 100.982 198.863 100.922 199.181 100.932H199.32C199.883 100.729 200.409 100.434 200.875 100.059C201.629 99.4202 202.315 98.6666 203.424 98.8154H203.467V93.0554C200.491 92.9834 197.462 92.0282 195.753 89.441C195.134 88.481 195.686 87.6506 196.497 87.3242C196.513 87.2338 196.553 87.1494 196.613 87.08C196.673 87.0106 196.751 86.959 196.838 86.9306L201.067 85.625L193.92 79.5578L186.528 77.0522C186.528 77.0522 184.555 82.4186 181.977 82.3994C179.4 82.3802 175.344 87.6314 174.902 90.3194C174.461 93.0074 177.753 94.2506 174.902 95.6618C172.051 97.073 172.982 100.687 171.753 103.183C170.635 105.473 166.997 103.385 165.201 103.841C162.033 104.652 162.801 109.395 158.865 109.831C158.016 109.927 157.152 109.783 156.297 109.831C155.524 109.89 154.772 110.111 154.089 110.479C153.753 110.635 153.472 110.89 153.283 111.209C152.577 112.615 155.078 114.439 153.998 115.582C152.587 115.731 151.43 116.724 150.125 117.271C147.096 118.534 143.688 117.271 140.477 116.619C137.615 116.093 134.706 115.868 131.798 115.947C129.691 115.947 127.176 116.071 127.958 117.838L128.131 117.963C128.726 118.397 129.176 119.001 129.422 119.695C129.601 119.876 129.743 120.089 129.84 120.324C129.908 120.559 129.92 120.806 129.875 121.046C129.83 121.287 129.729 121.513 129.581 121.707C129.101 123.809 126.341 124.817 123.197 125.311C123.169 125.435 123.182 125.565 123.235 125.681C120.936 126.036 118.609 126.176 116.285 126.099C115.393 126.128 114.502 126.047 113.63 125.859C109.79 126.012 103.819 126.516 100.67 124.419C97.6318 122.393 97.9726 119.335 94.1326 118.083C91.987 117.382 92.251 115.644 91.219 114.041C89.7214 111.703 87.2686 112.505 86.1166 110.143C85.3438 108.55 82.8574 108.574 81.8926 107.086C81.3454 106.236 81.4462 105.132 81.6574 104.143C81.6854 103.909 81.7823 103.689 81.9358 103.51C82.123 103.332 82.4158 103.294 82.6126 103.135C83.0398 102.814 82.987 102.175 83.155 101.662C83.635 100.198 85.651 100.02 86.2846 98.6858C83.1598 96.3626 78.2686 94.9658 78.8926 89.9498C79.1422 87.9578 72.8158 87.017 71.0446 84.1898C69.2734 81.3626 65.803 85.9418 63.1054 80.1098C60.4078 74.2778 49.1086 75.5354 47.923 75.5402C46.7374 75.545 44.6686 81.329 41.683 82.1066C39.8686 82.5866 41.0974 84.5834 42.3454 86.4266C42.7489 86.324 43.1761 86.3735 43.5454 86.5658C43.5644 86.5813 43.5853 86.5943 43.6078 86.6042C44.1186 86.4817 44.6522 86.4916 45.1582 86.633C46.1182 86.9258 46.5982 87.7562 46.915 88.6346C46.9758 88.8069 46.9971 88.9906 46.9774 89.1722C47.2172 89.3839 47.3934 89.6581 47.4862 89.9642C47.5422 90.1615 47.5586 90.368 47.5343 90.5716C47.51 90.7753 47.4456 90.9721 47.3447 91.1507C47.2438 91.3293 47.1084 91.4861 46.9465 91.612C46.7846 91.7379 46.5993 91.8304 46.4014 91.8842C46.3527 91.8973 46.3029 91.9053 46.2526 91.9082L46.171 91.9898C45.9257 92.1733 45.6327 92.2823 45.327 92.3035C45.0214 92.3248 44.7161 92.2576 44.4478 92.1098C44.2322 92.0129 44.0265 91.8956 43.8334 91.7594C43.5646 92.3066 42.9646 92.7578 41.683 93.0314C38.6926 93.6698 37.9774 97.2458 38.6926 99.4538C38.7758 99.6968 38.7858 99.9588 38.7214 100.207C39.8926 100.207 41.0734 100.347 42.1918 100.371C45.2254 100.495 45.2446 105.171 42.1918 105.099C42.0334 105.099 41.875 105.099 41.7118 105.099C41.5708 105.437 41.3584 105.741 41.0892 105.989C40.8199 106.238 40.5002 106.425 40.1518 106.539C39.464 106.805 38.806 107.143 38.1886 107.547C38.3902 109.419 38.7886 111.641 38.5342 113.561C38.8361 113.624 39.1342 113.704 39.427 113.801C39.9336 113.964 40.4016 114.229 40.8027 114.579C41.2037 114.929 41.5294 115.356 41.7598 115.836C41.9948 115.687 42.2659 115.605 42.5441 115.598C42.8222 115.592 43.0969 115.661 43.339 115.798C43.5576 115.928 43.741 116.11 43.8732 116.328C44.0054 116.545 44.0824 116.792 44.0974 117.046C44.2078 117.07 44.3167 117.101 44.4238 117.137C44.4854 117.102 44.5496 117.071 44.6158 117.046C44.8011 116.951 45.0076 116.904 45.2158 116.911C45.4224 116.904 45.6274 116.951 45.811 117.046C45.9951 117.112 46.1601 117.222 46.291 117.367C46.3574 117.441 46.4199 117.518 46.4782 117.598L46.6702 117.747C46.8617 117.937 47.0006 118.173 47.0734 118.433C47.0734 118.567 47.107 118.707 47.1262 118.846C47.1379 119.053 47.0914 119.259 46.9918 119.441C46.9277 119.626 46.8169 119.791 46.6702 119.921C46.5414 120.069 46.3758 120.18 46.1902 120.243C46.0074 120.34 45.8018 120.386 45.595 120.377C45.4953 120.373 45.396 120.363 45.2974 120.348C45.1083 120.628 44.8171 120.823 44.4862 120.891C43.6306 121.071 42.7409 120.996 41.9278 120.675C41.5687 120.755 41.1985 120.773 40.8334 120.727C40.5829 120.692 40.3368 120.631 40.099 120.545C39.5676 120.877 38.9855 121.12 38.3758 121.265C38.4434 122.915 38.4194 124.567 38.3038 126.214C38.3038 126.406 38.3038 126.598 38.3038 126.799C39.3799 127.212 40.3842 127.792 41.2798 128.518C41.6032 128.75 41.8464 129.077 41.9758 129.454H42.0142C42.7414 129.4 43.4699 129.539 44.1262 129.857C45.0526 130.284 45.0862 131.643 44.443 132.295C44.275 132.463 44.107 132.617 43.939 132.775C43.9269 133.104 43.8107 133.421 43.6071 133.68C43.4036 133.939 43.1231 134.126 42.8062 134.215C42.5928 134.269 42.3764 134.309 42.1582 134.335C41.5901 134.77 40.8958 135.008 40.1806 135.012H40.0894C40.0049 135.344 39.8122 135.638 39.5418 135.847C39.2713 136.057 38.9387 136.17 38.5966 136.169C38.4815 136.162 38.3661 136.162 38.251 136.169C38.3038 136.169 37.939 136.356 38.0638 136.251C37.9123 136.392 37.7814 136.553 37.675 136.731C37.2025 137.498 36.5563 138.144 35.7886 138.617C35.5331 138.761 35.2413 138.828 34.9486 138.809C34.546 139.388 34.1836 139.995 33.8638 140.623H208.003C208.029 140.479 208.04 140.333 208.037 140.187C207.346 139.926 206.775 139.42 206.433 138.766Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.505 135.051H186.542V140.835H203.505V135.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.025 135.051H168.062V140.835H185.025V135.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.54 135.051H149.577V140.835H166.54V135.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.06 135.051H131.097V140.835H148.06V135.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.576 135.051H112.613V140.835H129.576V135.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.096 135.051H94.1328V140.835H111.096V135.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6111 135.051H75.6479V140.835H92.6111V135.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1263 135.051H57.1631V140.835H74.1263V135.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6463 135.051H38.6831V140.835H55.6463V135.051Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.505 121.246H186.542V127.03H203.505V121.246Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.025 121.246H168.062V127.03H185.025V121.246Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.54 121.246H149.577V127.03H166.54V121.246Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.06 121.246H131.097V127.03H148.06V121.246Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.096 121.246H94.1328V127.03H111.096V121.246Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6111 121.246H75.6479V127.03H92.6111V121.246Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1263 121.246H57.1631V127.03H74.1263V121.246Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6463 121.246H38.6831V127.03H55.6463V121.246Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.505 107.446H186.542V113.23H203.505V107.446Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.026 107.446H168.062V113.23H185.026V107.446Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.54 107.446H149.577V113.23H166.54V107.446Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6107 107.446H75.6475V113.23H92.6107V107.446Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1263 107.446H57.1631V113.23H74.1263V107.446Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6458 107.446H38.6826V113.23H55.6458V107.446Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.505 93.6416H186.542V99.4256H203.505V93.6416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.026 93.6416H168.062V99.4256H185.026V93.6416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3197 92.1417L75.2617 97.8281L91.9387 100.931L92.9967 95.2447L76.3197 92.1417Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1263 93.6416H57.1631V99.4256H74.1263V93.6416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6458 93.6416H38.6826V99.4256H55.6458V93.6416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.265 128.148H177.302V133.932H194.265V128.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.785 128.148H158.822V133.932H175.785V128.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.301 128.148H140.337V133.932H157.301V128.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.816 128.148H121.853V133.932H138.816V128.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.336 128.148H103.373V133.932H120.336V128.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.851 128.148H84.8877V133.932H101.851V128.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3709 128.148H66.4077V133.932H83.3709V128.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.886 128.148H47.9229V133.932H64.886V128.148Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.265 114.344H177.302V120.128H194.265V114.344Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.785 114.344H158.822V120.128H175.785V114.344Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.301 114.344H140.337V120.128H157.301V114.344Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.816 114.344H121.853V120.128H138.816V114.344Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.851 114.344H84.8877V120.128H101.851V114.344Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3709 114.344H66.4077V120.128H83.3709V114.344Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.886 114.344H47.9229V120.128H64.886V114.344Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.265 100.544H177.302V106.328H194.265V100.544Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.785 100.544H158.822V106.328H175.785V100.544Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3709 100.544H66.4077V106.328H83.3709V100.544Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.886 100.544H47.9229V106.328H64.886V100.544Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.105 79.8359H184.142V85.6199H201.105V79.8359Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.766 78.3574L166.267 88.6299L169.769 93.2327L183.268 82.9603L179.766 78.3574Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1263 79.8359H57.1631V85.6199H74.1263V79.8359Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6458 79.8359H38.6826V85.6199H55.6458V79.8359Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.265 86.7393H177.302V92.5233H194.265V86.7393Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2791 86.6608L66.3159 88.1875L66.8365 93.9715L83.7997 92.4448L83.2791 86.6608Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.886 86.7393H47.9229V92.5233H64.886V86.7393Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.636 72.092L177.055 77.8467L193.932 79.5521L194.513 73.7974L177.636 72.092Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.886 72.9336H47.9229V78.7176H64.886V72.9336Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203.506 135.051H186.542V140.835H203.506V135.051Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.026 135.051H168.062V140.835H185.026V135.051Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.541 135.051H149.578V140.835H166.541V135.051Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.061 135.051H131.098V140.835H148.061V135.051Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.576 135.051H112.613V140.835H129.576V135.051Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.096 135.051H94.1328V140.835H111.096V135.051Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6111 135.051H75.6479V140.835H92.6111V135.051Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1263 135.051H57.1631V140.835H74.1263V135.051Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6463 135.051H38.6831V140.835H55.6463V135.051Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.506 121.246H186.542V127.03H203.506V121.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.026 121.246H168.062V127.03H185.026V121.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.541 121.246H149.578V127.03H166.541V121.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.061 121.246H131.098V127.03H148.061V121.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.096 121.246H94.1328V127.03H111.096V121.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6111 121.246H75.6479V127.03H92.6111V121.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1263 121.246H57.1631V127.03H74.1263V121.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6463 121.246H38.6831V127.03H55.6463V121.246Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.505 107.446H186.542V113.23H203.505V107.446Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.026 107.446H168.062V113.23H185.026V107.446Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.54 107.446H149.577V113.23H166.54V107.446Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.6111 107.446H75.6479V113.23H92.6111V107.446Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1263 107.446H57.1631V113.23H74.1263V107.446Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6463 107.446H38.6831V113.23H55.6463V107.446Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.505 93.6416H186.542V99.4256H203.505V93.6416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.026 93.6416H168.062V99.4256H185.026V93.6416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.3197 92.1417L75.2617 97.8281L91.9387 100.931L92.9967 95.2447L76.3197 92.1417Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1263 93.6416H57.1631V99.4256H74.1263V93.6416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6463 93.6416H38.6831V99.4256H55.6463V93.6416Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.265 128.148H177.302V133.932H194.265V128.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.785 128.148H158.822V133.932H175.785V128.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.301 128.148H140.337V133.932H157.301V128.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.816 128.148H121.853V133.932H138.816V128.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.336 128.148H103.373V133.932H120.336V128.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.851 128.148H84.8877V133.932H101.851V128.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3709 128.148H66.4077V133.932H83.3709V128.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8865 128.148H47.9233V133.932H64.8865V128.148Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.265 114.344H177.302V120.128H194.265V114.344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.785 114.344H158.822V120.128H175.785V114.344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.301 114.344H140.337V120.128H157.301V114.344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.816 114.344H121.853V120.128H138.816V114.344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.851 114.344H84.8877V120.128H101.851V114.344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3709 114.344H66.4077V120.128H83.3709V114.344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.8865 114.344H47.9233V120.128H64.8865V114.344Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.265 100.544H177.302V106.328H194.265V100.544Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.785 100.544H158.822V106.328H175.785V100.544Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.3714 100.544H66.4082V106.328H83.3714V100.544Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.886 100.544H47.9229V106.328H64.886V100.544Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.106 79.8359H184.143V85.6199H201.106V79.8359Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.766 78.3574L166.267 88.6299L169.769 93.2327L183.268 82.9603L179.766 78.3574Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.1263 79.8359H57.1631V85.6199H74.1263V79.8359Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.6463 79.8359H38.6831V85.6199H55.6463V79.8359Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.265 86.7393H177.302V92.5233H194.265V86.7393Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2791 86.6608L66.3159 88.1875L66.8365 93.9715L83.7997 92.4448L83.2791 86.6608Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.886 86.7393H47.9229V92.5233H64.886V86.7393Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.636 72.092L177.055 77.8467L193.932 79.5521L194.513 73.7974L177.636 72.092Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.886 72.9336H47.9229V78.7176H64.886V72.9336Z",
    fill: "#FAFAFA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M143.75 141.93C143.375 141.455 142.877 141.093 142.31 140.883C141.211 140.528 141.259 139.39 140.169 138.901C139.08 138.411 138.484 138.944 135.148 138.781C131.812 138.618 133.809 138.301 129.638 137.446C125.467 136.592 127.876 137.413 126.139 137.053C124.401 136.693 123.331 136.626 121.737 136.126C120.144 135.627 118.785 135.334 117.417 133.909C116.049 132.483 114.638 133.299 113.376 133.429C112.113 133.558 109.968 133.909 104.16 134.73C98.3515 135.55 102.393 136.338 100.876 137.61C99.3595 138.882 96.7099 137.355 95.4475 138.219C94.1851 139.083 91.0315 140.139 89.0923 140.048C87.5275 139.976 86.7595 141.387 86.5195 141.934L143.75 141.93Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M143.75 141.93C143.375 141.455 142.877 141.093 142.31 140.883C141.211 140.528 141.259 139.39 140.169 138.901C139.08 138.411 138.484 138.944 135.148 138.781C131.812 138.618 133.809 138.301 129.638 137.446C125.467 136.592 127.876 137.413 126.139 137.053C124.401 136.693 123.331 136.626 121.737 136.126C120.144 135.627 118.785 135.334 117.417 133.909C116.049 132.483 114.638 133.299 113.376 133.429C112.113 133.558 109.968 133.909 104.16 134.73C98.3515 135.55 102.393 136.338 100.876 137.61C99.3595 138.882 96.7099 137.355 95.4475 138.219C94.1851 139.083 91.0315 140.139 89.0923 140.048C87.5275 139.976 86.7595 141.387 86.5195 141.934L143.75 141.93Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.851 135.607L104.145 138.982L119.63 135.209L117.249 131.811L101.851 135.607Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M101.851 135.607L104.145 138.982L119.63 135.209L117.249 131.811L101.851 135.607Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.566 138.982L121.853 135.176L124.258 136.582L127.406 137.009L123.456 141.065L117.566 138.982Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M117.566 138.982L121.853 135.176L124.258 136.582L127.406 137.009L123.456 141.065L117.566 138.982Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.8956 141.929C82.2956 141.325 81.278 140.374 80.822 140.293C80.1334 140.149 79.4226 140.149 78.734 140.293C77.5964 140.465 77.6924 139.366 76.646 138.982C75.5996 138.598 73.6076 137.84 72.4796 137.36C71.3516 136.88 70.6748 137.36 69.9164 137.773C69.158 138.185 67.6364 137.931 65.6588 138.973C63.6812 140.014 62.1308 140.825 60.8012 141.056C60.0414 141.227 59.3139 141.519 58.646 141.92L82.8956 141.929Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M82.8956 141.929C82.2956 141.325 81.278 140.374 80.822 140.293C80.1334 140.149 79.4226 140.149 78.734 140.293C77.5964 140.465 77.6924 139.366 76.646 138.982C75.5996 138.598 73.6076 137.84 72.4796 137.36C71.3516 136.88 70.6748 137.36 69.9164 137.773C69.158 138.185 67.6364 137.931 65.6588 138.973C63.6812 140.014 62.1308 140.825 60.8012 141.056C60.0414 141.227 59.3139 141.519 58.646 141.92L82.8956 141.929Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.388 81.7718C124.58 81.9686 123.98 82.8518 123.053 83.7494C122.127 84.647 121.22 85.1894 121.032 85.0118C120.845 84.8342 121.44 83.9318 122.367 83.039C123.293 82.1462 124.2 81.5798 124.388 81.7718Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.597 84.0029L136.243 95.0429C136.299 95.0987 136.343 95.1649 136.374 95.2378C136.404 95.3107 136.42 95.3888 136.42 95.4677C136.42 95.5467 136.404 95.6248 136.374 95.6977C136.343 95.7706 136.299 95.8368 136.243 95.8925L134.731 97.3325C134.675 97.3891 134.609 97.4341 134.536 97.4648C134.462 97.4954 134.384 97.5112 134.304 97.5112C134.225 97.5112 134.146 97.4954 134.073 97.4648C133.999 97.4341 133.933 97.3891 133.877 97.3325L123.23 86.2925L125.597 84.0029Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.087 84.5358L124.69 81.915L121.167 85.3182L123.735 86.8062L126.087 84.5358Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.087 84.5358L124.69 81.915L121.167 85.3182L123.735 86.8062L126.087 84.5358Z",
    fill: "#5D4010"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.432 81.5918L120.871 85.0283C120.806 85.0909 120.804 85.1942 120.867 85.259L121.21 85.6148C121.273 85.6797 121.376 85.6815 121.441 85.6189L125.002 82.1824C125.067 82.1198 125.069 82.0165 125.006 81.9517L124.663 81.5959C124.6 81.531 124.497 81.5292 124.432 81.5918Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M136.094 94.8848L136.243 95.0384C136.299 95.0941 136.343 95.1603 136.374 95.2332C136.404 95.3061 136.42 95.3842 136.42 95.4632C136.42 95.5421 136.404 95.6202 136.374 95.6931C136.343 95.766 136.299 95.8322 136.243 95.888L134.731 97.328C134.675 97.3846 134.609 97.4295 134.536 97.4602C134.462 97.4909 134.384 97.5067 134.304 97.5067C134.225 97.5067 134.146 97.4909 134.072 97.4602C133.999 97.4295 133.933 97.3846 133.877 97.328L133.728 97.1744L136.094 94.8848Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M127.949 88.8228C127.919 88.8566 127.882 88.8836 127.841 88.9022C127.799 88.9207 127.754 88.9303 127.709 88.9303C127.664 88.9303 127.619 88.9207 127.578 88.9022C127.536 88.8836 127.499 88.8566 127.469 88.8228L125.808 87.0996C125.775 87.069 125.749 87.0319 125.731 86.9906C125.712 86.9493 125.703 86.9047 125.703 86.8596C125.703 86.8145 125.712 86.7699 125.731 86.7285C125.749 86.6872 125.775 86.6501 125.808 86.6196C125.839 86.587 125.876 86.5611 125.918 86.5434C125.959 86.5257 126.003 86.5166 126.048 86.5166C126.093 86.5166 126.138 86.5257 126.179 86.5434C126.22 86.5611 126.257 86.587 126.288 86.6196L127.949 88.338C127.983 88.3686 128.01 88.406 128.029 88.4477C128.047 88.4895 128.057 88.5347 128.057 88.5804C128.057 88.6261 128.047 88.6712 128.029 88.713C128.01 88.7548 127.983 88.7922 127.949 88.8228Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.542 67.4287C172.042 69.8719 174.96 72.9871 177.605 76.2943C179.918 79.2079 181.282 82.7167 182.352 86.2015C183.084 88.6341 183.625 91.12 183.97 93.6367L180.912 94.3855C178.954 89.6479 176.957 84.5551 173.779 80.5903C171.383 78.1274 168.841 75.8112 166.166 73.6543C165.864 73.4047 165.206 72.8959 164.918 72.6511L168.542 67.4287Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.789 65.317C170.069 65.245 174.585 72.1522 174.585 72.1522L169.257 77.7778C169.257 77.7778 163.584 74.5426 160.473 71.7922C156.633 68.3986 160.761 65.3602 164.789 65.317Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M170.891 68.3882L170.735 68.5889L172.321 69.8254L172.477 69.6248L170.891 68.3882Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M168.235 66.3205L167.87 66.0373C167.594 65.9128 167.312 65.8023 167.025 65.7061L168.077 66.5221L168.235 66.3205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.563 70.7798L173.357 70.5254L173.309 70.583L173.563 70.7798Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.224 67.0875L169.068 67.2881L170.533 68.4302L170.689 68.2296L169.224 67.0875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.665 67.2802L160.147 66.877C160.08 66.9307 160.016 66.9884 159.955 67.0497L160.507 67.4818L160.665 67.2802Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M165.897 71.3423L165.741 71.543L167.206 72.6846L167.362 72.4839L165.897 71.3423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M161.661 68.0425L161.504 68.2432L162.95 69.3705L163.107 69.1699L161.661 68.0425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.568 72.6499L167.412 72.8506L168.998 74.0869L169.155 73.8862L167.568 72.6499Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.301 69.3101L163.145 69.5107L164.75 70.7618L164.907 70.5611L163.301 69.3101Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.987 74.85L171.163 75.7668L171.341 75.5796L170.146 74.6436L169.987 74.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.891 68.7766L167.118 69.7686L168.583 70.9104L169.356 69.9185L167.891 68.7766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.651 65.4739L162.878 66.4658L164.325 67.5929L165.098 66.601L163.651 65.4739Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.296 66.7473L164.523 67.7393L166.128 68.9903L166.901 67.9983L165.296 66.7473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.365 73.0786L172.714 74.1298L173.582 73.213L172.138 72.0898L171.365 73.0786Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.564 70.0823L168.791 71.0742L170.377 72.3105L171.15 71.3186L169.564 70.0823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.343 69.7258L159.57 70.7178L161.017 71.8449L161.79 70.8529L160.343 69.7258Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.588 73.0286L163.814 74.0205L165.28 75.1624L166.053 74.1704L164.588 73.0286Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.986 68.6621C158.942 68.9163 158.942 69.1759 158.986 69.4301L159.36 68.9501L158.986 68.6621Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.192 77.1538L169.257 77.7778L169.862 77.1394L168.83 76.333L168.192 77.1538Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.253 74.3262L165.48 75.315L166.531 76.131L167.112 76.4958L167.842 75.5598L166.253 74.3262Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.991 71.0022L161.218 71.9941L162.824 73.2452L163.597 72.2532L161.991 71.0022Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.427 70.5967C159.461 70.6495 159.494 70.7023 159.533 70.7551L159.571 70.7071L159.427 70.5967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.704 65.4033H163.584L163.651 65.4561L163.704 65.4033Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.655 68.0286L162.879 66.4638L162.044 65.8398L161.684 65.979L160.666 67.2798L161.655 68.0286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.51 67.469L159.354 68.9531L160.345 69.7262L161.502 68.242L160.51 67.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.663 67.2613L160.507 67.4619L161.499 68.235L161.655 68.0343L160.663 67.2613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.663 67.2613L160.507 67.4619L161.499 68.235L161.655 68.0343L160.663 67.2613Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.651 65.4756L163.584 65.4229C163.059 65.5036 162.543 65.6354 162.043 65.8165L162.878 66.4644L163.651 65.4756Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.651 65.4756L163.584 65.4229C163.059 65.5036 162.543 65.6354 162.043 65.8165L162.878 66.4644L163.651 65.4756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.571 70.7069L160.339 69.7181L159.36 68.9453L158.985 69.4253C159.053 69.8412 159.207 70.2385 159.437 70.5917L159.571 70.7069Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.571 70.7069L160.339 69.7181L159.36 68.9453L158.985 69.4253C159.053 69.8412 159.207 70.2385 159.437 70.5917L159.571 70.7069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.753 70.7727L163.596 72.2568L164.588 73.0299L165.745 71.5458L164.753 70.7727Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.224 67.0742L169.392 66.863C169.039 66.6301 168.674 66.4169 168.298 66.2246L168.235 66.3014L169.224 67.0742Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.073 66.4912L166.899 67.998L167.891 68.7711L169.065 67.2642L168.073 66.4912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.133 68.9931L164.911 70.5605L165.903 71.3336L167.125 69.7662L166.133 68.9931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.826 73.2422L162.624 73.5014C162.96 73.7462 163.301 73.9814 163.646 74.231L163.814 74.015L162.826 73.2422Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M168.235 66.3052L168.079 66.5059L169.071 67.2789L169.227 67.0782L168.235 66.3052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.235 66.3052L168.079 66.5059L169.071 67.2789L169.227 67.0782L168.235 66.3052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.906 70.5679L164.75 70.7686L165.742 71.5414L165.898 71.3407L164.906 70.5679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.906 70.5679L164.75 70.7686L165.742 71.5414L165.898 71.3407L164.906 70.5679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.904 68.0149L166.131 69.0068L167.123 69.7799L167.896 68.7879L166.904 68.0149Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.904 68.0149L166.131 69.0068L167.123 69.7799L167.896 68.7879L166.904 68.0149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.596 72.2581L162.823 73.25L163.815 74.023L164.588 73.0311L163.596 72.2581Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.596 72.2581L162.823 73.25L163.815 74.023L164.588 73.0311L163.596 72.2581Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.733 69.8102L172.512 69.5654L172.479 69.6086L172.733 69.8102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.325 69.8232L171.151 71.3301L172.143 72.1031L173.317 70.5963L172.325 69.8232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.995 74.0667L167.839 75.5508L168.831 76.3238L169.987 74.8397L168.995 74.0667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.375 72.3066L169.154 73.874L170.146 74.6471L171.367 73.0796L170.375 72.3066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.32 69.81L173.309 70.5828L173.357 70.5252C173.17 70.2996 172.959 70.0452 172.733 69.81L172.479 69.6084L172.32 69.81Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.32 69.81L173.309 70.5828L173.357 70.5252C173.17 70.2996 172.959 70.0452 172.733 69.81L172.479 69.6084L172.32 69.81Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.149 73.8687L168.992 74.0693L169.984 74.8424L170.141 74.6417L169.149 73.8687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.149 73.8687L168.992 74.0693L169.984 74.8424L170.141 74.6417L169.149 73.8687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.15 71.3196L170.377 72.3115L171.369 73.0846L172.142 72.0926L171.15 71.3196Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.15 71.3196L170.377 72.3115L171.369 73.0846L172.142 72.0926L171.15 71.3196Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.842 75.5605L167.112 76.4966L168.192 77.1542L168.831 76.3333L167.842 75.5605Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.842 75.5605L167.112 76.4966L168.192 77.1542L168.831 76.3333L167.842 75.5605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.016 71.835L160.8 72.0798L160.997 72.243L161.203 71.9838L161.016 71.835Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M164.321 67.5917L163.1 69.1592L163.3 69.3156L164.522 67.7481L164.321 67.5917Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M162.941 69.3606L161.784 70.8447L161.985 71.0011L163.141 69.517L162.941 69.3606Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M165.298 66.7573L166.291 65.4805C166.198 65.4579 166.103 65.4403 166.008 65.4277L165.091 66.5989L165.298 66.7573Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.103 69.1665L162.946 69.3672L163.147 69.5236L163.303 69.3229L163.103 69.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M163.103 69.1665L162.946 69.3672L163.147 69.5236L163.303 69.3229L163.103 69.1665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.097 66.6086L164.324 67.6006L164.525 67.757L165.298 66.765L165.097 66.6086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M165.097 66.6086L164.324 67.6006L164.525 67.757L165.298 66.765L165.097 66.6086Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.784 70.8459L161.011 71.8379L161.211 71.9943L161.984 71.0023L161.784 70.8459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.784 70.8459L161.011 71.8379L161.211 71.9943L161.984 71.0023L161.784 70.8459Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M167.213 72.6907L166.057 74.1748L166.257 74.3312L167.414 72.847L167.213 72.6907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.88 68.375L171.053 68.1494L170.861 67.9814L170.679 68.2167L170.88 68.375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M165.279 75.1572L165.192 75.2724L165.404 75.4116L165.48 75.3156L165.279 75.1572Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.532 68.415L169.357 69.9219L169.558 70.0783L170.732 68.5714L170.532 68.415Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.591 70.9208L167.369 72.4883L167.57 72.6447L168.791 71.0772L168.591 70.9208Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M170.688 68.2183L170.531 68.4189L170.732 68.5753L170.888 68.3747L170.688 68.2183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.688 68.2183L170.531 68.4189L170.732 68.5753L170.888 68.3747L170.688 68.2183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.37 72.4976L167.214 72.6982L167.414 72.8547L167.571 72.6541L167.37 72.4976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M167.37 72.4976L167.214 72.6982L167.414 72.8547L167.571 72.6541L167.37 72.4976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.361 69.926L168.588 70.918L168.789 71.0743L169.562 70.0824L169.361 69.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.361 69.926L168.588 70.918L168.789 71.0743L169.562 70.0824L169.361 69.926Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.06 74.183L165.287 75.1748L165.488 75.3312L166.261 74.3394L166.06 74.183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.06 74.183L165.287 75.1748L165.488 75.3312L166.261 74.3394L166.06 74.183Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M174.586 72.152L174.533 72.0752L173.976 72.7952L174.586 72.152Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.283 77.5477L173.851 70.3525L175.181 71.8645L169.378 78.4021L168.283 77.5477Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.181 71.8645L173.102 74.2069L169.546 78.2149L169.378 78.4069L168.283 77.5477L168.35 77.4613L168.466 77.3173L171.926 72.8437L173.544 70.7509L173.851 70.3525L175.181 71.8645Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.103 74.207L169.546 78.215C169.117 78.0158 168.715 77.7626 168.351 77.4614C168.145 77.292 167.954 77.1057 167.779 76.9046C166.575 75.5222 166.003 73.3382 167.203 70.3574C168.938 70.8376 170.549 71.6856 171.927 72.8438C172.292 73.1692 172.622 73.5329 172.911 73.9286C172.98 74.0176 173.044 74.1105 173.103 74.207Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.554 56.451C146.525 56.7534 146.299 56.9694 146.103 56.931C145.906 56.8926 145.791 56.6286 145.834 56.3262C145.877 56.0238 146.088 55.8078 146.285 55.8462C146.482 55.8846 146.597 56.163 146.554 56.451Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.751 56.7637C146.238 57.6289 145.61 58.4201 144.883 59.1157C145.067 59.2969 145.288 59.4361 145.531 59.524C145.774 59.6118 146.032 59.6461 146.29 59.6245L146.751 56.7637Z",
    fill: "#ED847E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.467 54.6373C146.444 54.6354 146.421 54.638 146.398 54.6452C146.376 54.6523 146.355 54.6638 146.337 54.679C146.32 54.6942 146.305 54.7127 146.294 54.7336C146.284 54.7544 146.277 54.7772 146.275 54.8005C146.281 54.8359 146.296 54.8692 146.319 54.8965C146.33 54.9205 146.346 54.9419 146.365 54.9593C146.385 54.9766 146.409 54.9896 146.434 54.9973C146.659 55.0136 146.877 55.0825 147.07 55.1983C147.263 55.3142 147.427 55.4739 147.547 55.6645C147.571 55.7061 147.609 55.7375 147.654 55.7526C147.699 55.7677 147.749 55.7654 147.792 55.7461C147.813 55.7355 147.832 55.7208 147.847 55.703C147.862 55.6851 147.873 55.6644 147.881 55.6421C147.888 55.6198 147.89 55.5963 147.888 55.573C147.886 55.5496 147.88 55.5269 147.869 55.5061C147.723 55.2588 147.519 55.0505 147.275 54.8992C147.031 54.7479 146.754 54.658 146.467 54.6373Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.078 60.9825C146.104 61.1698 146.139 61.3557 146.184 61.5392C146.428 62.5956 146.989 63.5521 147.792 64.28C147.994 64.4668 148.211 64.6369 148.44 64.7888C149.309 65.3878 150.349 65.6862 151.403 65.6386C152.457 65.5909 153.466 65.1998 154.277 64.5248C156.418 62.8064 156.619 60.56 157.267 56.792C157.431 55.9151 157.367 55.0109 157.083 54.1653C156.799 53.3196 156.304 52.5605 155.644 51.96C154.985 51.3595 154.183 50.9374 153.314 50.7339C152.446 50.5303 151.54 50.552 150.682 50.7969C146.794 51.8913 145.642 57.4737 146.078 60.9825Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.792 64.2798C147.994 64.4665 148.211 64.6366 148.44 64.7886C149.036 65.199 149.715 65.4707 150.43 65.5837C151.144 65.6966 151.875 65.648 152.568 65.4414C152.45 64.9666 152.273 64.5085 152.04 64.0782C150.634 63.737 149.159 63.807 147.792 64.2798Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.632 67.0357C156.777 69.4837 152.352 71.1589 152.352 71.1589C152.352 71.1589 149.39 71.8501 149.496 70.7557C150.878 69.6805 151.224 68.5717 151.037 67.5013C150.898 66.85 150.63 66.2331 150.249 65.6869C150.053 65.3749 149.15 64.4917 148.915 64.2037L152.64 58.2373C153.326 61.0933 155.001 66.1237 157.632 67.0357Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.643 49.1169C151.68 48.8049 154.483 48.6369 156.129 49.2609C161.193 51.2577 160.205 54.2433 160.205 54.2433C159.969 53.6064 159.56 53.0479 159.024 52.6305C162.494 59.9409 154.997 64.2897 154.997 64.2897C153.024 63.0753 150.168 63.4497 150.168 63.4497C150.168 63.4497 149.995 59.9457 149.208 58.7265C148.421 57.5073 148.152 55.0929 148.651 53.8257C149.15 52.5585 147.753 53.0097 147.753 53.0097C146.913 51.9729 149.126 49.5729 150.643 49.1169Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.653 58.2806C150.541 58.6276 150.354 58.9456 150.105 59.212C149.856 59.4783 149.552 59.6864 149.213 59.8215C148.402 60.0615 148.018 58.9143 148.253 57.7863C148.474 56.7879 149.16 55.4246 149.962 55.7078C150.763 55.991 151.037 57.287 150.653 58.2806Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.731 52.3574C149.731 52.3574 146.371 60.3542 147.106 63.527C147.106 63.527 145.541 61.1702 149.002 52.487L149.731 52.3574Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.539 52.2803C152.539 52.2803 154.401 56.4083 156.461 57.8579C158.52 59.3075 159.869 58.2707 159.869 58.2707L160.541 55.7075C160.541 55.7075 159.859 57.6275 158.87 57.4451C157.881 57.2627 155.933 56.0051 154.392 52.6019L152.539 52.2803Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.539 52.2803C152.539 52.2803 154.401 56.4083 156.461 57.8579C158.52 59.3075 159.869 58.2707 159.869 58.2707L160.541 55.7075C160.541 55.7075 159.859 57.6275 158.87 57.4451C157.881 57.2627 155.933 56.0051 154.392 52.6019L152.539 52.2803Z",
    fill: "#54380A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.486 52.7507C146.486 52.7507 147.6 49.0595 149.65 47.9507C151.699 46.8419 156.086 47.5091 158.448 49.1555C160.81 50.8019 160.896 54.7187 160.728 55.4435C160.339 57.1235 155.501 51.9779 151.637 51.9059C147.773 51.8339 146.486 52.7507 146.486 52.7507Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.486 52.7507C146.486 52.7507 147.6 49.0595 149.65 47.9507C151.699 46.8419 156.086 47.5091 158.448 49.1555C160.81 50.8019 160.896 54.7187 160.728 55.4435C160.339 57.1235 155.501 51.9779 151.637 51.9059C147.773 51.8339 146.486 52.7507 146.486 52.7507Z",
    fill: "#54380A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.274 47.6722C150.274 47.6722 151.176 45.9778 151.916 45.7522C152.655 45.5266 157.512 46.7794 158.688 47.893C159.864 49.0066 160.988 52.3474 160.224 55.4674L157.848 54.8914C157.848 54.8914 158.434 51.2434 156.802 49.5154C154.92 47.5138 150.274 47.6722 150.274 47.6722Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.687 54.1234C144.687 54.1234 146.343 55.2706 148.685 53.6002C151.027 51.9298 154.239 53.0194 156.509 54.5602C158.119 55.6565 159.905 56.4682 161.789 56.9602L160.747 55.4194C160.747 55.4194 158.755 55.1266 155.947 52.8802C153.139 50.6338 148.133 51.1282 146.491 52.741L144.687 54.1234Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.712 68.9126C149.712 68.9126 152.083 65.1878 156.182 64.871C160.282 64.5542 158.846 68.9126 158.846 68.9126H149.712Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.712 68.9126C149.712 68.9126 152.083 65.1878 156.182 64.871C160.282 64.5542 158.846 68.9126 158.846 68.9126H149.712Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57 88.5729C169.541 90.4929 158.487 94.0449 155.554 94.9905C154.872 93.1809 155.429 87.7185 152.376 81.7377C151.442 79.9252 150.275 78.2422 148.906 76.7313C147.46 75.1401 145.839 73.7182 144.072 72.4929C144.072 72.4929 152.736 64.8801 163.579 65.5473C163.579 65.5473 172.8 71.1777 175.57 88.5729Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.863 67.9378L155.931 68.5752L156.01 68.8168L157.943 68.1794L157.863 67.9378Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.688 68.6572L153.946 69.2314L154.026 69.473L155.767 68.8988L155.688 68.6572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.747 69.6381L150.787 70.2842L150.867 70.5258L152.827 69.8798L152.747 69.6381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.411 72.0518L144.072 72.4933L144.327 72.6806L145.498 72.2918L145.411 72.0518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.547 70.3619L148.833 70.9268L148.912 71.1684L150.626 70.6035L150.547 70.3619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.97 66.268L161.06 66.8975L161.139 67.1391L163.049 66.5096L162.97 66.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.816 66.9752L159.052 67.5566L159.131 67.7983L160.896 67.2168L160.816 66.9752Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M147.641 71.309L145.658 71.9629L145.738 72.2045L147.721 71.5506L147.641 71.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.323 66.0853L164.203 65.9893L164.242 66.1093L164.323 66.0853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.382 73.7822L155.641 74.3564L155.72 74.598L157.462 74.0238L157.382 73.7822Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M154.445 74.754L152.485 75.4004L152.565 75.642L154.525 74.9956L154.445 74.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.55 73.0866L157.617 73.7236L157.697 73.9652L159.63 73.3282L159.55 73.0866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.506 72.1168L160.742 72.6982L160.822 72.9399L162.586 72.3584L162.506 72.1168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.971 70.5775L168.451 70.4191L168.288 70.2031L167.895 70.3327L167.971 70.5775Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.668 71.3926L162.758 72.0225L162.837 72.2641L164.748 71.6342L164.668 71.3926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.648 70.4193L165.856 71.0098L165.936 71.2514L167.727 70.6609L167.648 70.4193Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.242 75.4846L150.528 76.0498L150.608 76.2914L152.322 75.7262L152.242 75.4846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M149.333 76.4482L148.81 76.621C148.872 76.693 148.93 76.765 148.992 76.8322L149.414 76.693L149.333 76.4482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.34 75.5352L167.548 76.126L167.628 76.3676L169.42 75.7768L169.34 75.5352Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M156.141 79.8888L154.181 80.5352L154.26 80.7768L156.221 80.1304L156.141 79.8888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M166.362 76.5176L164.452 77.1475L164.532 77.3891L166.442 76.7592L166.362 76.5176Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M161.249 78.2064L159.316 78.8438L159.396 79.0854L161.329 78.448L161.249 78.2064Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.206 77.223L162.442 77.8057L162.522 78.0472L164.286 77.4646L164.206 77.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.938 80.6096L152.224 81.1748L152.303 81.4164L154.017 80.8512L153.938 80.6096Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.661 75.709L171.37 75.1474C171.326 75.0706 171.288 74.9938 171.25 74.917L169.584 75.469L169.661 75.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M158.687 79.4658L156.945 80.0342L157.024 80.2759L158.766 79.7075L158.687 79.4658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.931 83.3571L160.998 83.9941L161.078 84.2358L163.011 83.5987L162.931 83.3571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M165.9 82.3655L164.136 82.9473L164.216 83.1889L165.98 82.6071L165.9 82.3655Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.157 79.971L171.274 80.5918L171.354 80.8334L173.237 80.2126L173.157 79.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M171.041 80.6641L169.249 81.2549L169.329 81.4965L171.12 80.9057L171.041 80.6641Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.626 85.7598L154.114 86.2398C154.114 86.3262 154.157 86.4078 154.181 86.4894L155.707 85.9854L155.626 85.7598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.765 84.0615L159.023 84.6357L159.103 84.8773L160.844 84.3031L160.765 84.0615Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.832 85.0294L155.872 85.6758L155.952 85.9174L157.912 85.271L157.832 85.0294Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M168.054 81.6534L166.144 82.2832L166.223 82.5248L168.133 81.895L168.054 81.6534Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.587 87.5182L165.822 88.0996L165.902 88.3412L167.666 87.7598L167.587 87.5182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.522 90.1782L157.562 90.8242L157.641 91.0658L159.601 90.4198L159.522 90.1782Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.626 88.4919L162.693 89.1289L162.773 89.3705L164.706 88.7335L164.626 88.4919Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.325 90.887L155.611 91.4521L155.691 91.6938L157.405 91.1286L157.325 90.887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M174.853 85.1048L172.971 85.7256L173.05 85.9672L174.933 85.3464L174.853 85.1048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.461 89.1914L160.719 89.7656L160.799 90.0072L162.54 89.433L162.461 89.1914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.732 85.8038L170.94 86.3945L171.02 86.6361L172.812 86.0454L172.732 85.8038Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.74 86.809L167.83 87.4385L167.909 87.6801L169.819 87.0506L169.74 86.809Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.083 66.8525L155.011 66.627C154.416 66.8094 153.835 67.0061 153.278 67.2173L153.346 67.4237L155.083 66.8525Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.262 66.1334L157.238 66.0566C156.561 66.2006 155.899 66.3686 155.256 66.5366L155.328 66.7526L157.262 66.1334Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.107 67.6787C151.656 67.8707 151.219 68.0675 150.797 68.2691L152.155 67.8179L152.107 67.6787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.021 71.2929L154.279 71.8613L154.669 73.0561L156.411 72.4876L156.021 71.2929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.549 70.0531L156.616 70.6904L157.01 71.8848L158.942 71.2474L158.549 70.0531Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.32 73.4189L146.338 74.0765L146.419 74.3309C146.712 74.5853 147 74.8349 147.269 75.0893L148.709 74.6093L148.32 73.4189Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.25 69.1662L166.963 68.5998C166.632 68.2254 166.311 67.8942 166.003 67.5918L164.847 67.9758L165.25 69.1662Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.666 68.3497L161.756 68.9795L162.15 70.1738L164.06 69.544L163.666 68.3497Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.513 69.0677L159.749 69.6494L160.143 70.8438L161.907 70.262L161.513 69.0677Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M151.246 72.4553L149.532 73.0205L149.926 74.2148L151.64 73.6496L151.246 72.4553Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.449 71.7296L151.489 72.376L151.883 73.5703L153.843 72.9239L153.449 71.7296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.202 74.1771L161.438 74.7588L161.832 75.9531L163.596 75.3714L163.202 74.1771Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.134 76.8487L153.174 77.4951L153.568 78.6895L155.528 78.0431L155.134 76.8487Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.689 76.414L155.947 76.9824L156.337 78.1771L158.079 77.6087L157.689 76.414Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.96 73.6064L170.27 73.1744C170.045 72.7904 169.819 72.4256 169.589 72.0752L168.566 72.4112L168.96 73.6064Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.238 75.1625L158.305 75.7998L158.699 76.9942L160.631 76.3568L160.238 75.1625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.35 73.4737L163.44 74.1035L163.834 75.2979L165.744 74.668L165.35 73.4737Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.93 77.5696L151.216 78.1348L151.61 79.3291L153.324 78.7639L152.93 77.5696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.338 72.4854L166.546 73.0762L166.94 74.2705L168.732 73.6798L168.338 72.4854Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.92 80.263L159.987 80.9004L160.381 82.0947L162.314 81.4574L161.92 80.263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.357 81.5263L157.615 82.0947L158.005 83.2894L159.747 82.721L159.357 81.5263Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.613 82.6836L153.053 83.1972C153.216 83.5908 153.374 83.9796 153.533 84.3684L155.021 83.8884L154.613 82.6836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.022 77.5997L168.23 78.1904L168.624 79.3848L170.416 78.794L170.022 77.5997Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.822 81.9445L154.861 82.5908L155.255 83.7852L157.215 83.1388L156.822 81.9445Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.886 79.2864L163.122 79.8682L163.516 81.0625L165.28 80.4808L164.886 79.2864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.035 78.584L165.125 79.2139L165.519 80.4082L167.429 79.7784L167.035 78.584Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.143 76.9065L170.261 77.5273L170.655 78.7217L172.537 78.1009L172.143 76.9065Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.163 84.9769L164.398 85.5527L164.788 86.7475L166.553 86.1716L166.163 84.9769Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.433 86.0977L159.691 86.6719L160.085 87.8662L161.827 87.292L161.433 86.0977Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.83 82.0013L171.948 82.6221L172.342 83.8164L174.224 83.1956L173.83 82.0013Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.505 87.0587L156.545 87.7051L156.939 88.8994L158.899 88.2531L158.505 87.0587Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.687 88.9853L156.298 87.7949L154.594 88.3517C154.594 88.3901 154.594 88.4237 154.618 88.4621L154.973 89.5517L156.687 88.9853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.705 82.7003L169.913 83.291L170.307 84.4854L172.098 83.8946L171.705 82.7003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.723 83.6836L166.812 84.3135L167.206 85.5078L169.116 84.878L168.723 83.6836Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.204 85.9296L161.271 86.5605L161.66 87.7553L163.594 87.1244L163.204 85.9296Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.698 91.7646L160.956 92.333L161.346 93.5277L163.088 92.9593L162.698 91.7646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.868 91.0654L162.934 91.6963L163.324 92.891L165.257 92.2601L164.868 91.0654Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M174.024 88.9375L175.546 88.4335C175.478 88.0111 175.406 87.5935 175.33 87.1855L173.63 87.7423L174.024 88.9375Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.389 87.8243L171.597 88.415L171.991 89.6094L173.783 89.0186L173.389 87.8243Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.186 92.1777L158.223 92.8209L158.616 94.0065L159.576 93.6993L160.579 93.3681L160.186 92.1777Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.247 89.528L166.483 90.1094L166.877 91.3038L168.641 90.7224L168.247 89.528Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.264 93.4687L156.653 94.6351L158.371 94.0831L157.983 92.9023L156.264 93.4687Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.992 89.3824L168.082 90.0059L168.471 91.2006L170.382 90.5771L169.992 89.3824Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.683 91.707L155.088 91.9038C155.16 92.6238 155.222 93.2574 155.294 93.7902L156.254 93.4686L155.683 91.707Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.973 89.5518L154.81 89.6046C154.92 90.3342 154.997 91.0158 155.064 91.6398L155.606 91.4622L154.973 89.5518Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.223 81.4592L152.448 81.896L152.299 81.416L152.223 81.4592Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.921 74.2155L148.727 74.6094L149.332 76.4465L150.527 76.0526L149.921 74.2155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.923 71.154L147.729 71.5479L148.343 73.4123L149.538 73.0185L148.923 71.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M151.603 79.333L151.061 79.5106C151.445 80.0866 151.791 80.6578 152.103 81.229L152.218 81.1906L151.603 79.333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.834 70.9232L148.354 69.5312C147.965 69.7568 147.595 69.9825 147.254 70.1937L147.619 71.3169L148.834 70.9232Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.605 76.2998L149.415 76.6934L149.755 77.7302C149.947 77.9654 150.135 78.2102 150.307 78.4358L151.21 78.1382L150.605 76.2998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M148.83 70.9267L147.636 71.3203L147.715 71.5619L148.91 71.1683L148.83 70.9267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.83 70.9267L147.636 71.3203L147.715 71.5619L148.91 71.1683L148.83 70.9267Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.535 76.0388L149.34 76.4326L149.42 76.6742L150.614 76.2804L150.535 76.0388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.535 76.0388L149.34 76.4326L149.42 76.6742L150.614 76.2804L150.535 76.0388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.218 81.2002L152.103 81.2386L152.223 81.469L152.299 81.445L152.218 81.2002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.218 81.2002L152.103 81.2386L152.223 81.469L152.299 81.445L152.218 81.2002Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.607 91.4629L155.064 91.6405C155.064 91.7317 155.064 91.8181 155.088 91.9045L155.684 91.7077L155.607 91.4629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.607 91.4629L155.064 91.6405C155.064 91.7317 155.064 91.8181 155.088 91.9045L155.684 91.7077L155.607 91.4629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.525 73.03L148.331 73.4238L148.725 74.6182L149.919 74.2243L149.525 73.03Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M149.525 73.03L148.331 73.4238L148.725 74.6182L149.919 74.2243L149.525 73.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M151.2 78.1377L150.298 78.4353C150.567 78.7953 150.816 79.1505 151.051 79.5105L151.594 79.3329L151.2 78.1377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M151.2 78.1377L150.298 78.4353C150.567 78.7953 150.816 79.1505 151.051 79.5105L151.594 79.3329L151.2 78.1377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.618 88.4629C154.69 88.8517 154.752 89.2357 154.81 89.6053L154.973 89.5525L154.618 88.4629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.618 88.4629C154.69 88.8517 154.752 89.2357 154.81 89.6053L154.973 89.5525L154.618 88.4629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.294 93.7904C155.337 94.197 155.424 94.5977 155.554 94.9856L156.653 94.6351L156.264 93.4688L155.294 93.7904Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.294 93.7904C155.337 94.197 155.424 94.5977 155.554 94.9856L156.653 94.6351L156.264 93.4688L155.294 93.7904Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.036 72.5271L153.841 72.9209L154.447 74.758L155.641 74.3642L155.036 72.5271Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.719 74.6071L154.525 75.001L155.131 76.8381L156.325 76.4442L155.719 74.6071Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.111 84.8737L157.917 85.2676L158.506 87.0545L159.701 86.6607L159.111 84.8737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.028 69.4763L152.833 69.8701L153.448 71.7346L154.643 71.3407L154.028 69.4763Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.68 88.408L158.485 88.7979L159.109 90.7085L160.304 90.3186L159.68 88.408Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.416 79.738L156.221 80.1318L156.819 81.9461L158.014 81.5523L157.416 79.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.718 77.6355L155.523 78.0293L156.137 79.8892L157.331 79.4954L156.718 77.6355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.407 82.7478L157.212 83.1416L157.835 85.0289L159.029 84.635L158.407 82.7478Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.352 67.4138L152.157 67.8076L152.754 69.6174L153.948 69.2235L153.352 67.4138Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.803 90.0144L159.609 90.4082L160.191 92.1724L161.385 91.7785L160.803 90.0144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M153.95 69.2181L152.756 69.6123L152.836 69.8539L154.03 69.4596L153.95 69.2181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.95 69.2181L152.756 69.6123L152.836 69.8539L154.03 69.4596L153.95 69.2181Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.64 74.361L154.445 74.7549L154.525 74.9965L155.719 74.6026L155.64 74.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.64 74.361L154.445 74.7549L154.525 74.9965L155.719 74.6026L155.64 74.361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.331 79.5046L156.137 79.8984L156.216 80.14L157.411 79.7462L157.331 79.5046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.331 79.5046L156.137 79.8984L156.216 80.14L157.411 79.7462L157.331 79.5046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.027 84.6345L157.833 85.0283L157.912 85.2699L159.107 84.8761L159.027 84.6345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.027 84.6345L157.833 85.0283L157.912 85.2699L159.107 84.8761L159.027 84.6345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.715 89.7866L159.521 90.1807L159.6 90.4223L160.795 90.0282L160.715 89.7866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.715 89.7866L159.521 90.1807L159.6 90.4223L160.795 90.0282L160.715 89.7866Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.346 67.4242L153.279 67.2178C152.875 67.3666 152.487 67.5202 152.107 67.6978L152.155 67.837L153.346 67.4242Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.346 67.4242L153.279 67.2178C152.875 67.3666 152.487 67.5202 152.107 67.6978L152.155 67.837L153.346 67.4242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.636 71.3544L153.442 71.748L153.836 72.9425L155.03 72.5488L154.636 71.3544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.636 71.3544L153.442 71.748L153.836 72.9425L155.03 72.5488L154.636 71.3544Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.332 76.4362L155.138 76.8301L155.532 78.0244L156.726 77.6306L156.332 76.4362Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.332 76.4362L155.138 76.8301L155.532 78.0244L156.726 77.6306L156.332 76.4362Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.011 81.5603L156.817 81.9541L157.211 83.1484L158.405 82.7546L158.011 81.5603Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.011 81.5603L156.817 81.9541L157.211 83.1484L158.405 82.7546L158.011 81.5603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.695 86.6648L158.501 87.0586L158.895 88.2529L160.089 87.8591L159.695 86.6648Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.695 86.6648L158.501 87.0586L158.895 88.2529L160.089 87.8591L159.695 86.6648Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.372 91.7958L160.177 92.1895L160.571 93.3839L161.765 92.9902L161.372 91.7958Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.372 91.7958L160.177 92.1895L160.571 93.3839L161.765 92.9902L161.372 91.7958Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.521 78.0652L161.326 78.459L161.924 80.2733L163.119 79.8795L162.521 78.0652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.913 88.322L164.719 88.7158L165.3 90.48L166.495 90.0861L165.913 88.322Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.863 67.9471L159.053 67.5534L158.482 65.8398L157.92 65.9358L157.263 66.1518L157.863 67.9471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.792 86.7361L163.598 87.126L164.221 89.0366L165.416 88.6468L164.792 86.7361Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.833 75.9558L160.638 76.3496L161.251 78.2095L162.446 77.8157L161.833 75.9558Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.786 71.3982L158.591 71.7881L159.19 73.6258L160.385 73.2359L159.786 71.3982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.687 91.6836V91.7365L166.882 91.3524V91.29L165.687 91.6836Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.138 67.7868L157.943 68.1807L158.558 70.0451L159.753 69.6513L159.138 67.7868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.217 83.1911L163.022 83.585L163.612 85.3719L164.806 84.9781L164.217 83.1911Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.833 72.9226L159.639 73.3164L160.245 75.1535L161.439 74.7597L160.833 72.9226Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.517 81.0603L162.322 81.4541L162.945 83.3413L164.139 82.9475L163.517 81.0603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.051 67.5566L157.856 67.9502L157.936 68.1918L159.13 67.7982L159.051 67.5566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.051 67.5566L157.856 67.9502L157.936 68.1918L159.13 67.7982L159.051 67.5566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M160.75 72.6814L159.555 73.0752L159.635 73.3168L160.829 72.923L160.75 72.6814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M160.75 72.6814L159.555 73.0752L159.635 73.3168L160.829 72.923L160.75 72.6814Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.445 77.8152L161.251 78.209L161.331 78.4506L162.525 78.0568L162.445 77.8152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M162.445 77.8152L161.251 78.209L161.331 78.4506L162.525 78.0568L162.445 77.8152Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.132 82.9657L162.938 83.3594L163.017 83.601L164.212 83.2074L164.132 82.9657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.132 82.9657L162.938 83.3594L163.017 83.601L164.212 83.2074L164.132 82.9657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M165.824 88.103L164.63 88.4971L164.71 88.7387L165.904 88.3446L165.824 88.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.824 88.103L164.63 88.4971L164.71 88.7387L165.904 88.3446L165.824 88.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.262 66.133L157.92 65.917L157.238 66.0562L157.262 66.133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.262 66.133L157.92 65.917L157.238 66.0562L157.262 66.133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.746 69.6708L158.552 70.0645L158.945 71.2589L160.14 70.8652L159.746 69.6708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.746 69.6708L158.552 70.0645L158.945 71.2589L160.14 70.8652L159.746 69.6708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.437 74.7614L160.242 75.1553L160.636 76.3496L161.83 75.9558L161.437 74.7614Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.437 74.7614L160.242 75.1553L160.636 76.3496L161.83 75.9558L161.437 74.7614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.126 79.862L161.932 80.2559L162.325 81.4502L163.52 81.0564L163.126 79.862Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.126 79.862L161.932 80.2559L162.325 81.4502L163.52 81.0564L163.126 79.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.8 85.0019L163.605 85.3955L163.999 86.5899L165.194 86.1963L164.8 85.0019Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.8 85.0019L163.605 85.3955L163.999 86.5899L165.194 86.1963L164.8 85.0019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.488 90.0954L165.293 90.4893L165.687 91.6836L166.882 91.2898L166.488 90.0954Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.488 90.0954L165.293 90.4893L165.687 91.6836L166.882 91.2898L166.488 90.0954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.326 81.5114L168.132 81.9053L168.721 83.6922L169.915 83.2984L169.326 81.5114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.255 69.155L164.061 69.5488L164.666 71.3859L165.861 70.9921L165.255 69.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.24 66.124L163.046 66.5176L163.66 68.3821L164.855 67.9885L164.24 66.124Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.309 84.4948L169.114 84.8887L169.744 86.7987L170.938 86.4049L170.309 84.4948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.635 76.3757L166.44 76.7695L167.039 78.5838L168.233 78.19L167.635 76.3757Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.626 79.3816L167.432 79.7754L168.054 81.6626L169.248 81.2688L168.626 79.3816Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.799 89.9991L170.828 90.0951L172.023 89.7111L171.989 89.6055L170.799 89.9991Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.079 65.8977C163.762 65.6625 163.599 65.5473 163.599 65.5473C163.311 65.5473 163.027 65.5233 162.744 65.5137L162.989 66.2625L164.079 65.8977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.938 71.236L164.744 71.6299L165.35 73.467L166.544 73.0731L165.938 71.236Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.018 86.6521L169.823 87.0459L170.405 88.8101L171.599 88.4162L171.018 86.6521Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.942 74.2634L165.748 74.6572L166.361 76.5171L167.556 76.1233L166.942 74.2634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M163.051 66.5023L164.242 66.1087L164.203 65.9887L164.079 65.8975L162.97 66.2623L163.051 66.5023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.051 66.5023L164.242 66.1087L164.203 65.9887L164.079 65.8975L162.97 66.2623L163.051 66.5023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M165.864 70.988L164.669 71.3818L164.749 71.6234L165.943 71.2296L165.864 70.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.864 70.988L164.669 71.3818L164.749 71.6234L165.943 71.2296L165.864 70.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.551 76.1325L166.356 76.5264L166.436 76.768L167.63 76.3741L167.551 76.1325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.551 76.1325L166.356 76.5264L166.436 76.768L167.63 76.3741L167.551 76.1325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.247 81.2673L168.052 81.6611L168.132 81.9027L169.326 81.5089L169.247 81.2673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.247 81.2673L168.052 81.6611L168.132 81.9027L169.326 81.5089L169.247 81.2673Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M170.942 86.3962L169.748 86.79L169.828 87.0316L171.022 86.6378L170.942 86.3962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.942 86.3962L169.748 86.79L169.828 87.0316L171.022 86.6378L170.942 86.3962Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.864 67.9646L163.67 68.3584L164.064 69.5527L165.258 69.1589L164.864 67.9646Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M164.864 67.9646L163.67 68.3584L164.064 69.5527L165.258 69.1589L164.864 67.9646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.542 73.0837L165.348 73.4775L165.741 74.6719L166.936 74.278L166.542 73.0837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.542 73.0837L165.348 73.4775L165.741 74.6719L166.936 74.278L166.542 73.0837Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.23 78.1784L167.036 78.5723L167.43 79.7666L168.624 79.3728L168.23 78.1784Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.23 78.1784L167.036 78.5723L167.43 79.7666L168.624 79.3728L168.23 78.1784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.915 83.2937L168.721 83.6875L169.115 84.8818L170.309 84.488L169.915 83.2937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M169.915 83.2937L168.721 83.6875L169.115 84.8818L170.309 84.488L169.915 83.2937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.592 88.4257L170.397 88.8193L170.791 90.0137L171.985 89.6201L171.592 88.4257Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.592 88.4257L170.397 88.8193L170.791 90.0137L171.985 89.6201L171.592 88.4257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.195 76.8804L171.979 76.4004L172.143 76.9044L172.195 76.8804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M174.854 85.1166H174.898C174.744 84.4398 174.581 83.7918 174.418 83.1582L174.23 83.2206L174.854 85.1166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.16 79.9812L173.405 79.8996C173.175 79.2564 172.925 78.6372 172.695 78.042L172.536 78.0948L173.16 79.9812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.827 82.0117L174.062 81.9349C173.88 81.3205 173.688 80.7205 173.486 80.1445L173.242 80.2261L173.827 82.0117Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M175.008 85.5877C175.008 85.5061 174.975 85.4293 174.956 85.3525H174.932L175.008 85.5877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M173.242 80.2405L173.487 80.1589C173.458 80.0773 173.429 79.9957 173.405 79.9141L173.16 79.9957L173.242 80.2405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.242 80.2405L173.487 80.1589C173.458 80.0773 173.429 79.9957 173.405 79.9141L173.16 79.9957L173.242 80.2405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M174.931 85.3619H174.955L174.898 85.1123H174.854L174.931 85.3619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M174.931 85.3619H174.955L174.898 85.1123H174.854L174.931 85.3619Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.536 78.0944L172.694 78.0416C172.531 77.648 172.363 77.2592 172.214 76.8848H172.162L172.536 78.0944Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M172.536 78.0944L172.694 78.0416C172.531 77.648 172.363 77.2592 172.214 76.8848H172.162L172.536 78.0944Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M174.24 83.2066L174.427 83.1442C174.315 82.7314 174.2 82.3282 174.082 81.9346L173.847 82.0114L174.24 83.2066Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M174.24 83.2066L174.427 83.1442C174.315 82.7314 174.2 82.3282 174.082 81.9346L173.847 82.0114L174.24 83.2066Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M145.738 72.2148L145.493 72.2916L146.06 74.0148L146.199 74.1252L146.352 74.0772L145.738 72.2148Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M145.656 71.9698L145.469 71.4082L145.253 71.5666L145.411 72.0466L145.656 71.9698Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.652 71.976L145.41 72.0557L145.49 72.2973L145.731 72.2177L145.652 71.976Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M145.652 71.976L145.41 72.0557L145.49 72.2973L145.731 72.2177L145.652 71.976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.199 74.1252L146.434 74.3315L146.352 74.0771L146.199 74.1252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M146.199 74.1252L146.434 74.3315L146.352 74.0771L146.199 74.1252Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.792 70.2758L150.221 68.5479L149.985 68.663L150.547 70.3574L150.792 70.2758Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.935 88.8949L156.694 88.9746L157.324 90.8846L157.565 90.805L156.935 88.8949Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M157.64 91.0629L157.398 91.1426L157.98 92.9067L158.221 92.8271L157.64 91.0629Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.952 85.9223L155.71 86.002L156.299 87.789L156.541 87.7094L155.952 85.9223Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.249 83.7914L155.007 83.8711L155.63 85.7582L155.872 85.6785L155.249 83.7914Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M154.262 80.7768L154.02 80.8564L154.618 82.6707L154.86 82.5911L154.262 80.7768Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M152.565 75.6508L152.324 75.7305L152.93 77.5676L153.171 77.4879L152.565 75.6508Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.564 78.6733L153.323 78.7529L153.936 80.6128L154.178 80.5332L153.564 78.6733Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.869 70.5102L150.627 70.5898L151.242 72.4543L151.484 72.3746L150.869 70.5102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M151.881 73.5619L151.639 73.6416L152.245 75.4786L152.487 75.3989L151.881 73.5619Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.795 70.264L150.554 70.3438L150.634 70.5853L150.875 70.5055L150.795 70.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.795 70.264L150.554 70.3438L150.634 70.5853L150.875 70.5055L150.795 70.264Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M152.486 75.4076L152.244 75.4873L152.324 75.7289L152.565 75.6492L152.486 75.4076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M152.486 75.4076L152.244 75.4873L152.324 75.7289L152.565 75.6492L152.486 75.4076Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M154.177 80.5424L153.936 80.6221L154.015 80.8637L154.257 80.7841L154.177 80.5424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M154.177 80.5424L153.936 80.6221L154.015 80.8637L154.257 80.7841L154.177 80.5424Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.869 85.6772L155.627 85.7568L155.707 85.9984L155.948 85.9188L155.869 85.6772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.869 85.6772L155.627 85.7568L155.707 85.9984L155.948 85.9188L155.869 85.6772Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.556 90.8217L157.314 90.9014L157.394 91.143L157.636 91.0634L157.556 90.8217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M157.556 90.8217L157.314 90.9014L157.394 91.143L157.636 91.0634L157.556 90.8217Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M151.481 72.3842L151.239 72.4639L151.633 73.6582L151.875 73.5785L151.481 72.3842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M151.481 72.3842L151.239 72.4639L151.633 73.6582L151.875 73.5785L151.481 72.3842Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M153.169 77.4887L152.927 77.5684L153.321 78.7628L153.562 78.6831L153.169 77.4887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M153.169 77.4887L152.927 77.5684L153.321 78.7628L153.562 78.6831L153.169 77.4887Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M154.858 82.5892L154.616 82.6689L155.01 83.8632L155.252 83.7835L154.858 82.5892Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M154.858 82.5892L154.616 82.6689L155.01 83.8632L155.252 83.7835L154.858 82.5892Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.543 87.6986L156.301 87.7783L156.695 88.9726L156.937 88.8929L156.543 87.6986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.543 87.6986L156.301 87.7783L156.695 88.9726L156.937 88.8929L156.543 87.6986Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M157.982 92.9029L158.371 94.0837L158.616 94.0069L158.222 92.8213L157.982 92.9029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M157.982 92.9029L158.371 94.0837L158.616 94.0069L158.222 92.8213L157.982 92.9029Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.328 66.7612L155.086 66.8408L155.683 68.6506L155.924 68.5709L155.328 66.7612Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M162.784 89.352L162.542 89.4316L163.124 91.1958L163.365 91.1161L162.784 89.352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.092 84.2162L160.851 84.2959L161.44 86.0829L161.681 86.0032L161.092 84.2162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M160.387 82.0853L160.146 82.165L160.768 84.0522L161.01 83.9725L160.387 82.0853Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M157.016 71.8696L156.774 71.9492L157.38 73.7863L157.622 73.7066L157.016 71.8696Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M157.704 73.9447L157.462 74.0244L158.068 75.8614L158.31 75.7817L157.704 73.9447Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M159.391 79.0903L159.149 79.1699L159.748 80.9842L159.989 80.9045L159.391 79.0903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M163.507 92.4039V92.4375L163.752 92.3559V92.3223L163.507 92.4039Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.654 69.342L155.412 69.4209L156.021 71.2859L156.262 71.2071L155.654 69.342Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M158.699 76.9877L158.457 77.0674L159.07 78.9273L159.312 78.8476L158.699 76.9877Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M162.075 87.1938L161.833 87.2734L162.463 89.1835L162.704 89.1038L162.075 87.1938Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M155.926 68.5766L155.685 68.6562L155.764 68.8979L156.006 68.8182L155.926 68.5766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.926 68.5766L155.685 68.6562L155.764 68.8979L156.006 68.8182L155.926 68.5766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.621 73.7035L157.379 73.7832L157.459 74.0248L157.7 73.9451L157.621 73.7035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M157.621 73.7035L157.379 73.7832L157.459 74.0248L157.7 73.9451L157.621 73.7035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M159.311 78.8471L159.07 78.9268L159.149 79.1684L159.391 79.0887L159.311 78.8471Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M159.311 78.8471L159.07 78.9268L159.149 79.1684L159.391 79.0887L159.311 78.8471Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M161.007 83.9819L160.766 84.0615L160.845 84.3031L161.087 84.2235L161.007 83.9819Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.007 83.9819L160.766 84.0615L160.845 84.3031L161.087 84.2235L161.007 83.9819Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.287 89.6652L162.045 89.7441L162.124 89.986L162.366 89.9071L162.287 89.6652Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M162.287 89.6652L162.045 89.7441L162.124 89.986L162.366 89.9071L162.287 89.6652Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M155.328 66.7717L155.256 66.5557L155.011 66.6277L155.083 66.8533L155.328 66.7717Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M155.328 66.7717L155.256 66.5557L155.011 66.6277L155.083 66.8533L155.328 66.7717Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M156.62 70.6879L156.378 70.7676L156.772 71.9619L157.014 71.8822L156.62 70.6879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.62 70.6879L156.378 70.7676L156.772 71.9619L157.014 71.8822L156.62 70.6879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M158.304 75.7973L158.062 75.877L158.456 77.0713L158.698 76.9916L158.304 75.7973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M158.304 75.7973L158.062 75.877L158.456 77.0713L158.698 76.9916L158.304 75.7973Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M159.987 80.9174L159.746 80.9971L160.139 82.1915L160.381 82.1119L159.987 80.9174Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M159.987 80.9174L159.746 80.9971L160.139 82.1915L160.381 82.1119L159.987 80.9174Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.671 86.0219L161.429 86.1016L161.823 87.2959L162.065 87.2162L161.671 86.0219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.671 86.0219L161.429 86.1016L161.823 87.2959L162.065 87.2162L161.671 86.0219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.359 91.1274L163.117 91.207L163.511 92.4014L163.753 92.3217L163.359 91.1274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M163.359 91.1274L163.117 91.207L163.511 92.4014L163.753 92.3217L163.359 91.1274Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.797 86.0872L166.556 86.166L167.179 88.0767L167.421 87.9978L166.797 86.0872Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M165.526 80.3929L165.284 80.4727L165.907 82.3598L166.148 82.2801L165.526 80.3929Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M167.909 87.6674L167.667 87.7471L168.249 89.5112L168.49 89.4316L167.909 87.6674Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M164.536 77.3881L164.294 77.4678L164.893 79.282L165.134 79.2023L164.536 77.3881Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.137 67.1518L160.896 67.2314L161.51 69.096L161.752 69.0164L161.137 67.1518Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.644 90.7085L168.668 90.7853L168.912 90.7085V90.627L168.644 90.7085Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.059 66.8912L160.622 65.5664L160.363 65.5904L160.843 66.968L161.059 66.8912Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.222 82.5317L165.98 82.6113L166.569 84.3984L166.811 84.3188L166.222 82.5317Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M162.145 70.1879L161.904 70.2676L162.51 72.1047L162.751 72.025L162.145 70.1879Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M163.839 75.2865L163.598 75.3662L164.211 77.2261L164.453 77.1464L163.839 75.2865Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M162.835 72.268L162.594 72.3477L163.2 74.1848L163.441 74.1051L162.835 72.268Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M161.057 66.9008L160.815 66.9805L160.895 67.2221L161.137 67.1423L161.057 66.9008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.057 66.9008L160.815 66.9805L160.895 67.2221L161.137 67.1423L161.057 66.9008Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M162.751 72.0219L162.51 72.1016L162.589 72.3432L162.831 72.2635L162.751 72.0219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M162.751 72.0219L162.51 72.1016L162.589 72.3432L162.831 72.2635L162.751 72.0219Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M164.442 77.1665L164.2 77.2461L164.28 77.4877L164.521 77.4081L164.442 77.1665Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M164.442 77.1665L164.2 77.2461L164.28 77.4877L164.521 77.4081L164.442 77.1665Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M166.146 82.2787L165.904 82.3584L165.984 82.6L166.226 82.5203L166.146 82.2787Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.146 82.2787L165.904 82.3584L165.984 82.6L166.226 82.5203L166.146 82.2787Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.828 87.438L167.586 87.5176L167.666 87.7592L167.907 87.6796L167.828 87.438Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M167.828 87.438L167.586 87.5176L167.666 87.7592L167.907 87.6796L167.828 87.438Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M161.759 68.9779L161.518 69.0576L161.911 70.252L162.153 70.1723L161.759 68.9779Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M161.759 68.9779L161.518 69.0576L161.911 70.252L162.153 70.1723L161.759 68.9779Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M163.44 74.102L163.198 74.1816L163.592 75.376L163.833 75.2964L163.44 74.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M163.44 74.102L163.198 74.1816L163.592 75.376L163.833 75.2964L163.44 74.102Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M165.127 79.2162L164.886 79.2959L165.28 80.4902L165.521 80.4106L165.127 79.2162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M165.127 79.2162L164.886 79.2959L165.28 80.4902L165.521 80.4106L165.127 79.2162Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M166.395 84.9309L166.154 85.0098L166.544 86.2045L166.785 86.1256L166.395 84.9309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M166.395 84.9309L166.154 85.0098L166.544 86.2045L166.785 86.1256L166.395 84.9309Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.489 89.4526L168.247 89.5322L168.641 90.7266L168.882 90.647L168.489 89.4526Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.489 89.4526L168.247 89.5322L168.641 90.7266L168.882 90.647L168.489 89.4526Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M171.353 80.8422L171.112 80.9219L171.701 82.7089L171.942 82.6293L171.353 80.8422Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.76 89.0143L173.798 89.1343L174.043 89.0575L174.005 88.9375L173.76 89.0143Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M167.89 70.333L167.539 69.2674L167.098 68.749L167.645 70.4146L167.89 70.333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M172.335 83.8227L172.093 83.9023L172.723 85.8124L172.965 85.7327L172.335 83.8227Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.973 73.5903L168.731 73.6699L169.345 75.5298L169.586 75.4501L168.973 73.5903Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.651 78.7045L170.409 78.7842L171.032 80.6714L171.273 80.5918L170.651 78.7045Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.664 75.6976L169.423 75.7773L170.021 77.5915L170.263 77.5118L169.664 75.6976Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.054 85.9681L172.812 86.0479L173.394 87.8119L173.636 87.7322L173.054 85.9681Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M167.972 70.5737L167.73 70.6533L168.336 72.4905L168.578 72.4109L167.972 70.5737Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M167.89 70.3158L167.648 70.3955L167.728 70.6371L167.97 70.5574L167.89 70.3158Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M167.89 70.3158L167.648 70.3955L167.728 70.6371L167.97 70.5574L167.89 70.3158Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M169.586 75.4506L169.345 75.5303L169.424 75.7719L169.666 75.6922L169.586 75.4506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M169.586 75.4506L169.345 75.5303L169.424 75.7719L169.666 75.6922L169.586 75.4506Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M171.276 80.5942L171.034 80.6738L171.114 80.9154L171.355 80.8358L171.276 80.5942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M171.276 80.5942L171.034 80.6738L171.114 80.9154L171.355 80.8358L171.276 80.5942Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M172.962 85.7426L172.721 85.8223L172.8 86.0639L173.042 85.9843L172.962 85.7426Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M172.962 85.7426L172.721 85.8223L172.8 86.0639L173.042 85.9843L172.962 85.7426Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M168.575 72.4067L168.333 72.4863L168.727 73.6807L168.968 73.6011L168.575 72.4067Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M168.575 72.4067L168.333 72.4863L168.727 73.6807L168.968 73.6011L168.575 72.4067Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M170.263 77.5171L170.021 77.5967L170.415 78.7911L170.657 78.7115L170.263 77.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M170.263 77.5171L170.021 77.5967L170.415 78.7911L170.657 78.7115L170.263 77.5171Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M171.949 82.6127L171.707 82.6924L172.101 83.8867L172.343 83.8069L171.949 82.6127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M171.949 82.6127L171.707 82.6924L172.101 83.8867L172.343 83.8069L171.949 82.6127Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M173.638 87.725L173.396 87.8047L173.79 88.999L174.032 88.9194L173.638 87.725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M173.638 87.725L173.396 87.8047L173.79 88.999L174.032 88.9194L173.638 87.725Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.376 81.7378C151.442 79.9253 150.275 78.2423 148.906 76.7314C149.722 75.9634 150.917 75.5074 152.568 75.6514C153.108 77.6546 153.041 79.7727 152.376 81.7378Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.955 82.4528L141.984 80.96L142.037 82.9712L150.734 83.8256L150.955 82.4528Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.955 82.4528L141.984 80.96L142.037 82.9712L150.734 83.8256L150.955 82.4528Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.022 93.5843L187.67 94.6787C187.76 94.8276 187.789 95.0058 187.749 95.1753C187.71 95.3447 187.606 95.4921 187.459 95.5859L130.301 132.512L128.966 130.256L186.086 93.3635C186.162 93.3155 186.246 93.283 186.335 93.2681C186.423 93.2532 186.514 93.2562 186.601 93.2767C186.688 93.2973 186.77 93.3351 186.843 93.3879C186.915 93.4408 186.976 93.5075 187.022 93.5843Z",
    fill: "#407BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.022 93.5843L187.67 94.6787C187.76 94.8276 187.789 95.0058 187.749 95.1753C187.71 95.3447 187.606 95.4921 187.459 95.5859L130.301 132.512L128.966 130.256L186.086 93.3635C186.162 93.3155 186.246 93.283 186.335 93.2681C186.423 93.2532 186.514 93.2562 186.601 93.2767C186.688 93.2973 186.77 93.3351 186.843 93.3879C186.915 93.4408 186.976 93.5075 187.022 93.5843Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.541 131.481C127.541 131.481 123 124.857 124.406 117.844C125.711 122.139 127.737 126.18 130.397 129.796L127.541 131.481Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M127.541 131.481C127.541 131.481 123 124.857 124.406 117.844C125.711 122.139 127.737 126.18 130.397 129.796L127.541 131.481Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.491 133.093C128.491 133.093 132.11 140.269 138.926 142.419C135.796 139.204 133.233 135.481 131.347 131.408L128.491 133.093Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M128.491 133.093C128.491 133.093 132.11 140.269 138.926 142.419C135.796 139.204 133.233 135.481 131.347 131.408L128.491 133.093Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.741 131.173L128.387 133.958L132.498 131.528L130.853 128.743L126.741 131.173Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M126.741 131.173L128.387 133.958L132.498 131.528L130.853 128.743L126.741 131.173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.792 93.2575L180.749 98.1727L184.997 97.5247C184.997 97.5247 185.511 94.0927 183.024 92.6719L180.792 93.2575Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.824 99.887L185.415 100.036L184.997 97.5254L180.749 98.1734L181.824 99.887Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.021 132.45L194.242 135.964L186.125 136.813L185.909 133.3L194.021 132.45Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.4 136.107C194.39 136.093 194.375 136.083 194.359 136.078C194.343 136.073 194.325 136.073 194.309 136.078C194.293 136.083 194.278 136.092 194.268 136.105C194.258 136.118 194.252 136.134 194.251 136.15C194.251 136.213 194.15 137.624 194.549 138.07C194.621 138.157 194.724 138.212 194.837 138.224C194.901 138.236 194.968 138.228 195.027 138.201C195.087 138.173 195.136 138.128 195.168 138.07C195.288 137.85 195.168 137.432 194.962 137.024C194.8 136.703 194.612 136.397 194.4 136.107ZM194.4 136.405C194.77 136.957 195.154 137.758 195.019 138.003C195.019 138.037 194.966 138.08 194.846 138.07C194.812 138.068 194.778 138.058 194.747 138.042C194.717 138.025 194.69 138.002 194.669 137.974C194.633 137.932 194.604 137.885 194.582 137.835C194.432 137.373 194.37 136.886 194.4 136.4V136.405Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.371 136.083C194.358 136.076 194.343 136.072 194.328 136.072C194.313 136.072 194.298 136.076 194.285 136.083C194.251 136.083 193.44 136.602 193.301 137.163C193.261 137.326 193.287 137.499 193.373 137.643C193.498 137.84 193.627 137.85 193.718 137.821C194.107 137.706 194.424 136.616 194.414 136.15C194.417 136.139 194.417 136.128 194.414 136.117C194.403 136.103 194.388 136.091 194.371 136.083ZM193.464 137.206C193.627 136.838 193.898 136.528 194.242 136.318C194.194 136.822 193.906 137.595 193.67 137.667C193.67 137.667 193.594 137.691 193.517 137.562C193.507 137.548 193.499 137.534 193.493 137.518C193.445 137.422 193.434 137.31 193.464 137.206Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.8 135.997L192.13 132.56C192.099 132.497 192.091 132.426 192.107 132.358C192.123 132.29 192.161 132.229 192.216 132.186L194.731 130.199C194.792 130.151 194.862 130.117 194.938 130.1C195.013 130.083 195.091 130.084 195.166 130.101C195.241 130.119 195.312 130.153 195.372 130.201C195.432 130.25 195.48 130.311 195.514 130.381C196.094 131.643 196.896 133.482 197.654 135.051C198.538 136.89 199.402 138.411 200.443 140.576C201.072 141.877 199.93 142.875 199.546 142.391C197.808 140.168 196.771 138.171 194.414 136.669C194.15 136.508 193.937 136.275 193.8 135.997Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.857 138.824C190.857 138.824 164.894 143.432 156.734 141.171C151.627 139.755 151.454 126.051 152.414 113.6C152.693 109.914 153.081 106.338 153.461 103.222C154.2 97.1888 154.929 92.888 154.929 92.888L175.603 88.3184C175.603 88.3184 177.403 96.2672 174.72 102.368C174.121 103.834 173.205 105.149 172.038 106.219C170.872 107.29 169.483 108.089 167.971 108.56C167.971 108.56 166.152 114.373 164.707 120.296C163.387 125.715 162.369 131.226 163.339 132.478C164.779 134.331 190.541 132.454 190.541 132.454L190.857 138.824Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.857 138.824C190.857 138.824 164.894 143.432 156.734 141.171C151.627 139.755 151.454 126.051 152.414 113.6C152.693 109.914 153.081 106.338 153.461 103.222C154.2 97.1888 154.929 92.888 154.929 92.888L175.603 88.3184C175.603 88.3184 177.403 96.2672 174.72 102.368C174.121 103.834 173.205 105.149 172.038 106.219C170.872 107.29 169.483 108.089 167.971 108.56C167.971 108.56 166.152 114.373 164.707 120.296C163.387 125.715 162.369 131.226 163.339 132.478C164.779 134.331 190.541 132.454 190.541 132.454L190.857 138.824Z",
    fill: "#C9A976"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M152.856 108.839C152.702 110.384 152.558 111.983 152.434 113.6C155.362 115.578 160.402 118.607 164.707 120.292C165.965 115.136 167.501 110.072 167.88 108.839H152.856Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.71 138.906C147.727 138.902 147.742 138.894 147.754 138.882C147.766 138.87 147.774 138.855 147.778 138.838C147.781 138.821 147.779 138.803 147.771 138.787C147.763 138.772 147.75 138.759 147.734 138.752C147.682 138.723 146.453 138.018 145.867 138.181C145.812 138.192 145.76 138.215 145.714 138.248C145.669 138.281 145.631 138.324 145.603 138.373C145.566 138.426 145.545 138.49 145.545 138.555C145.545 138.62 145.566 138.684 145.603 138.738C145.747 138.944 146.184 139.002 146.635 139.002C146.996 139 147.355 138.968 147.71 138.906ZM147.442 138.781C146.784 138.872 145.896 138.867 145.733 138.642C145.709 138.613 145.69 138.56 145.733 138.454C145.752 138.419 145.779 138.389 145.811 138.366C145.843 138.342 145.881 138.327 145.92 138.32C145.974 138.312 146.029 138.312 146.083 138.32C146.563 138.391 147.024 138.554 147.442 138.8V138.781Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.744 138.892C147.756 138.883 147.765 138.871 147.771 138.858C147.777 138.844 147.779 138.829 147.778 138.815C147.778 138.776 147.677 137.826 147.23 137.461C147.166 137.403 147.09 137.36 147.007 137.335C146.924 137.31 146.836 137.304 146.75 137.317C146.52 137.317 146.453 137.456 146.438 137.548C146.376 137.946 147.216 138.709 147.643 138.901H147.677C147.7 138.907 147.724 138.903 147.744 138.892ZM147.125 137.586C147.391 137.892 147.559 138.272 147.605 138.676C147.173 138.412 146.597 137.816 146.645 137.576C146.645 137.576 146.645 137.5 146.808 137.48H146.861C146.958 137.485 147.051 137.522 147.125 137.586Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.953 138.661L148.68 139.957L145.349 132.507L148.622 131.211L151.953 138.661Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.071 138.416H151.911C151.98 138.416 152.048 138.439 152.102 138.483C152.156 138.527 152.194 138.588 152.208 138.656L152.904 141.786C152.922 141.861 152.922 141.94 152.904 142.016C152.887 142.092 152.852 142.162 152.803 142.223C152.754 142.283 152.692 142.331 152.621 142.363C152.55 142.396 152.473 142.412 152.395 142.41C151.008 142.41 149.007 142.309 147.264 142.309C145.224 142.309 143.463 142.419 141.072 142.419C139.632 142.419 139.229 140.955 139.834 140.826C142.589 140.221 144.835 140.158 147.216 138.69C147.47 138.521 147.766 138.426 148.071 138.416Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57 88.5732L173.918 104.332C173.102 106.208 168.744 109.65 166.69 109.914C165.023 110.111 163.347 110.223 161.669 110.25C158.75 110.317 155.635 110.216 152.803 110.082C150.989 109.996 149.294 109.89 147.84 109.804C145.19 109.65 143.342 109.554 143.083 109.717C142.123 110.312 150.965 134.634 150.965 134.634L145.541 134.749C145.541 134.749 133.44 114.008 132.317 107.12C131.899 104.576 131.544 101.408 136.387 98.9604C139.339 97.4772 147.509 96.834 152.227 96.5604C154.315 96.45 155.731 96.4165 155.731 96.4165L155.582 95.7636L154.934 92.8548L175.57 88.5732Z",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.57 88.5732L173.918 104.332C173.102 106.208 168.744 109.65 166.69 109.914C165.023 110.111 163.347 110.223 161.669 110.25C158.75 110.317 155.635 110.216 152.803 110.082C150.989 109.996 149.294 109.89 147.84 109.804C145.19 109.65 143.342 109.554 143.083 109.717C142.123 110.312 150.965 134.634 150.965 134.634L145.541 134.749C145.541 134.749 133.44 114.008 132.317 107.12C131.899 104.576 131.544 101.408 136.387 98.9604C139.339 97.4772 147.509 96.834 152.227 96.5604C154.315 96.45 155.731 96.4165 155.731 96.4165L155.582 95.7636L154.934 92.8548L175.57 88.5732Z",
    fill: "#C9A976"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.117 97.9377L171.134 97.1553C171.237 98.8881 171.237 100.626 171.134 102.358L169.166 103.726L167.515 103.006C167.479 101.311 167.346 99.6183 167.117 97.9377Z",
    fill: "#836433"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.231 93.0322L156.571 94.6882L154.594 95.0866L154.738 93.349L156.231 93.0322Z",
    fill: "#BB9B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.099 91.583L163.469 93.3014L157.315 94.5398L156.95 92.879L163.099 91.583Z",
    fill: "#BB9B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.77 89.9648L171.134 91.76L164.251 93.1424L163.891 91.4144L170.77 89.9648Z",
    fill: "#BB9B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.174 90.7428L171.936 91.5972H171.931L171.562 89.7972L175.771 88.9092L176.174 90.7428Z",
    fill: "#BB9B68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.038 88.8805L129.907 87.5893C129.648 87.4275 129.355 87.3297 129.051 87.3038C128.747 87.2779 128.442 87.3248 128.16 87.4405L126.753 88.0357C126.302 88.2302 125.942 88.5905 125.748 89.0424C125.554 89.4943 125.541 90.0033 125.712 90.4645L126.115 91.5301C126.232 91.8365 126.426 92.1077 126.679 92.3178C126.931 92.5279 127.232 92.6698 127.555 92.7301L129.893 93.1813C129.893 93.1813 132.11 93.0565 133.161 91.4725L132.038 88.8805Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.272 74.1253C150.781 77.8082 150.097 81.4629 149.223 85.0741C148.903 86.5514 148.451 87.9972 147.874 89.3941C145.594 94.2229 135.619 92.7541 131.362 91.9813L131.573 88.8373C133.93 88.5973 136.344 88.3573 138.6 87.9973C140.079 87.7285 141.677 87.4837 142.834 86.8021C142.93 86.7349 142.978 86.6725 142.891 86.7253C142.821 86.7777 142.761 86.8428 142.714 86.9173C142.671 86.9701 142.623 87.0709 142.637 87.0277C142.651 86.9845 142.637 87.0277 142.637 86.9797C143.597 82.5685 144.149 77.6389 144.979 73.1797L151.263 74.1397L151.272 74.1253Z",
    fill: "#FFC3BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.04 74.8067L142.646 82.7795L150.379 83.2595C151.418 80.4599 152.138 77.5519 152.525 74.5907C153.053 69.5171 144.206 69.7139 143.04 74.8067Z",
    fill: "#89652A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.12 73.7776L144.888 75.7754L145.14 75.8048L145.373 73.807L145.12 73.7776Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.87 76.0425L144.656 77.8877L144.908 77.9171L145.123 76.0719L144.87 76.0425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.517 72.5606L145.627 71.6006L145.354 71.7542L145.263 72.5318L145.517 72.5606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.505 79.1395L144.27 81.1611L144.522 81.1905L144.757 79.1689L144.505 79.1395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.231 81.4014L144.062 82.8702L144.317 82.8846L144.485 81.4302L144.231 81.4014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.22 76.6431L150.005 78.4883L150.258 78.5176L150.472 76.6724L150.22 76.6431Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.497 74.4134L150.265 76.4111L150.518 76.4405L150.75 74.4428L150.497 74.4134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M149.854 79.7381L149.619 81.7598L149.872 81.7891L150.106 79.7675L149.854 79.7381Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.888 73.184L151.08 71.5328C151.003 71.4834 150.923 71.4385 150.84 71.3984L150.634 73.1552L150.888 73.184Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M149.602 82.0254L149.462 83.2206L149.722 83.2398L149.856 82.0542L149.602 82.0254Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.676 79.3847L146.441 81.4062L147.691 81.5514L147.926 79.5299L146.676 79.3847Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.302 74.0374L147.069 76.0352L148.319 76.1804L148.551 74.1826L147.302 74.0374Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.685 72.9294L148.905 71.0574L147.83 70.9326L147.653 70.9566L147.441 72.7854L148.685 72.9294Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.41 81.6562L146.251 83.0098L147.504 83.0914L147.658 81.8002L146.41 81.6562Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.033 76.2837L146.818 78.1289L148.068 78.2741L148.282 76.4289L147.033 76.2837Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.074 78.2743L147.929 79.5234L149.875 79.7495L150.02 78.5004L148.074 78.2743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.897 77.9041L144.751 79.1533L146.673 79.3767L146.818 78.1275L144.897 77.9041Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.644 77.8736L142.92 77.6768L142.858 78.9296L144.5 79.1216L144.644 77.8736Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.125 79.7598L151.479 79.9182C151.584 79.5294 151.695 79.1166 151.8 78.6942L150.269 78.5166L150.125 79.7598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.649 77.8817L144.504 79.1309L144.757 79.1603L144.902 77.9111L144.649 77.8817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.649 77.8817L144.504 79.1309L144.757 79.1603L144.902 77.9111L144.649 77.8817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.024 78.5106L149.878 79.7598L150.131 79.7891L150.276 78.5399L150.024 78.5106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.024 78.5106L149.878 79.7598L150.131 79.7891L150.276 78.5399L150.024 78.5106Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.823 78.1336L146.678 79.3828L147.927 79.528L148.072 78.2788L146.823 78.1336Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.823 78.1336L146.678 79.3828L147.927 79.528L148.072 78.2788L146.823 78.1336Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.118 73.7796L145.263 72.5316L144.437 72.4355C144.074 72.7705 143.766 73.1609 143.525 73.5923L145.118 73.7796Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.744 74.4326L152.539 74.639V74.615C152.582 74.1973 152.554 73.7755 152.458 73.367L150.883 73.1846L150.744 74.4326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.677 72.9168L148.532 74.166L150.477 74.3918L150.622 73.1426L148.677 72.9168Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.508 72.5448L145.363 73.7939L147.285 74.0173L147.43 72.7681L145.508 72.5448Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.254 72.5164L145.109 73.7656L145.362 73.795L145.507 72.5457L145.254 72.5164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M145.254 72.5164L145.109 73.7656L145.362 73.795L145.507 72.5457L145.254 72.5164Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.635 73.1541L150.49 74.4033L150.743 74.4327L150.888 73.1835L150.635 73.1541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M150.635 73.1541L150.49 74.4033L150.743 74.4327L150.888 73.1835L150.635 73.1541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.435 72.7743L147.29 74.0234L148.539 74.1686L148.684 72.9195L147.435 72.7743Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.435 72.7743L147.29 74.0234L148.539 74.1686L148.684 72.9195L147.435 72.7743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.856 82.0542L150.792 82.1646C150.821 82.083 150.845 82.0014 150.874 81.915L149.89 81.7998L149.856 82.0542Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.264 81.1473L142.757 80.9697L142.743 81.2289L144.231 81.4017L144.264 81.1473Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M147.695 81.5539L147.666 81.8066L149.611 82.0331L149.641 81.7804L147.695 81.5539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.528 81.1907L144.499 81.4434L146.42 81.6667L146.45 81.414L144.528 81.1907Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.274 81.1614L144.245 81.4141L144.497 81.4435L144.527 81.1908L144.274 81.1614Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.274 81.1614L144.245 81.4141L144.497 81.4435L144.527 81.1908L144.274 81.1614Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M149.646 81.7864L149.616 82.0391L149.869 82.0684L149.898 81.8157L149.646 81.7864Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.646 81.7864L149.616 82.0391L149.869 82.0684L149.898 81.8157L149.646 81.7864Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M146.445 81.4153L146.416 81.668L147.665 81.8132L147.695 81.5605L146.445 81.4153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M146.445 81.4153L146.416 81.668L147.665 81.8132L147.695 81.5605L146.445 81.4153Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.888 75.7766L143.021 75.5605L143.011 75.8149L144.854 76.031L144.888 75.7766Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M148.309 76.1731L148.279 76.4258L150.225 76.6519L150.254 76.3992L148.309 76.1731Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.48 76.6831L152.203 76.8847C152.203 76.7983 152.232 76.7167 152.251 76.6303L150.514 76.4287L150.48 76.6831Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M145.145 75.8176L145.116 76.0703L147.037 76.2937L147.067 76.041L145.145 75.8176Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M144.878 75.7688L144.849 76.0215L145.102 76.0508L145.131 75.7981L144.878 75.7688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M144.878 75.7688L144.849 76.0215L145.102 76.0508L145.131 75.7981L144.878 75.7688Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M150.267 76.4133L150.238 76.666L150.49 76.6954L150.52 76.4427L150.267 76.4133Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.267 76.4133L150.238 76.666L150.49 76.6954L150.52 76.4427L150.267 76.4133Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M147.067 76.0373L147.038 76.29L148.287 76.4352L148.316 76.1825L147.067 76.0373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M147.067 76.0373L147.038 76.29L148.287 76.4352L148.316 76.1825L147.067 76.0373Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M150.499 71.2402C149.995 71.0459 149.464 70.931 148.925 70.8994V71.0578L150.499 71.2402Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M148.925 70.8992C148.56 70.8793 148.194 70.8905 147.831 70.9328L148.906 71.0576L148.925 70.8992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M148.925 70.8992C148.56 70.8793 148.194 70.8905 147.831 70.9328L148.906 71.0576L148.925 70.8992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.282 77.5333L126.518 72.1045C126.518 72.1045 123.23 73.2085 123.158 69.2725C123.158 69.2725 121.344 74.8021 116.895 71.3173C116.895 71.3173 116.563 75.1957 115.455 76.4821C114.346 77.7685 111.975 77.8261 111.975 77.8261C111.975 77.8261 113.645 79.5829 113.679 80.5861C113.712 81.5893 111.883 82.7221 111.883 82.7221L116.53 84.0469C116.53 84.0469 114.711 83.6773 114.797 81.3493C114.883 79.0213 117.221 75.3877 120.922 74.0485C124.623 72.7093 125.659 73.9573 124.282 77.5333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_826_2135"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 154,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404ErrorwithpersonlookingforRafiki1);
export default __webpack_public_path__ + "static/media/404 error with person looking for-rafiki 1.8646eacde05e50b73e867bc011fe96a9.svg";
export { ForwardRef as ReactComponent };